// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/projectdata.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AcceptCustomerThemeSuggestionRequest, AcceptCustomerThemeSuggestionResponse, ActivateContractRequest, ActivateContractResponse, AddMembersRequest, AddMembersResponse, AddPublicProtestDecisionRequest, AddPublicProtestDecisionResponse, AddVolumeDocumentRequest, AddVolumeDocumentResponse, ArchiveProjectRequest, ArchiveProjectResponse, AttachCustomerThemeEvidenceRequest, AttachCustomerThemeEvidenceResponse, BeginAwardComparisonRequest, BeginAwardComparisonResponse, BeginModificationComparisonRequest, BeginModificationComparisonResponse, CancelAwardComparisonRunRequest, CancelAwardComparisonRunResponse, CaptureProposalMaterialReviewRequest, ChangeCaptureLifecycleRequest, ChangeCaptureLifecycleResponse, CheckProjectWriteAccessRequest, CheckProjectWriteAccessResponse, CloseDeliverableWithEvidenceRequest, CloseDeliverableWithEvidenceResponse, CommitDraftRequest, CommitDraftResponse, CommitImportRequest, CommitImportResponse, CommitModificationRequest, CommitModificationResponse, CompareSectionVersionsRequest, CompareSectionVersionsResponse, ConfirmProposalComplianceCoverageRequest, ConvertCaptureToProposalRequest, ConvertCaptureToProposalResponse, ConvertProposalToPreAwardRequest, ConvertProposalToPreAwardResponse, CreateCaptureProjectRequest, CreateCaptureProjectResponse, CreateContractProjectFromProposalRequest, CreateContractProjectFromProposalResponse, CreateCustomerThemeRequest, CreateCustomerThemeResponse, CreateCustomVolumeRequest, CreateCustomVolumeResponse, CreateDraftRequest, CreateDraftResponse, CreateIndirectRateRequest, CreateIndirectRateResponse, CreateLibraryItemRequest, CreateLibraryItemResponse, CreatePricingRequest, CreatePricingResponse, CreateProjectChatRequest, CreateProjectChatResponse, CreateProjectRequest, CreateProjectResponse, CreateReviewSnapshotRequest, CreateReviewSnapshotResponse, CreateRfiResponseProjectRequest, CreateRfiResponseProjectResponse, DecideOciFlagRequest, DecideOciFlagResponse, DeleteBlackHatInputRequest, DeleteBlackHatInputResponse, DeleteCaptureCompetitionLinkRequest, DeleteCaptureCompetitionLinkResponse, DeleteCapturePlanAreaRequest, DeleteCapturePlanAreaResponse, DeleteCaptureTaskRequest, DeleteCaptureTaskResponse, DeleteCaptureTeamingLinkRequest, DeleteCaptureTeamingLinkResponse, DeleteCompetitiveFieldParticipantRequest, DeleteCompetitiveFieldParticipantResponse, DeleteCustomVolumeRequest, DeleteCustomVolumeResponse, DeleteDraftRequest, DeleteDraftResponse, DeleteEntityEdgeRequest, DeleteEntityEdgeResponse, DeleteEntityNodeRequest, DeleteEntityNodeResponse, DeleteIndirectRateRequest, DeleteIndirectRateResponse, DeleteOutlineSectionRequest, DeleteOutlineSectionResponse, DeletePricingRequest, DeletePricingResponse, DeleteProjectFileRequest, DeleteProjectFileResponse, DeleteProjectRequest, DeleteProjectResponse, DeleteProposalMilestoneRequest, DeleteProposalMilestoneResponse, DiffWorkbookVersionsRequest, DiffWorkbookVersionsResponse, DiscardChangeSetRequest, DiscardChangeSetResponse, EnsureArtifactForAttachmentRequest, EnsureArtifactForAttachmentResponse, EnsureDeliveryProgramRequest, EnsureDeliveryProgramResponse, ForkProjectChatRequest, ForkProjectChatResponse, GetActivationGateRequest, GetActivationGateResponse, GetAmbiguitiesRequest, GetAmbiguitiesResponse, GetAmendmentHistoryRequest, GetAmendmentHistoryResponse, GetAwardComparisonRunRequest, GetAwardComparisonRunResponse, GetBatchStatusRequest, GetBatchStatusResponse, GetBidBaselineRequest, GetBidBaselineResponse, GetCapturePlanRequest, GetCapturePlanResponse, GetCaptureProfileRequest, GetCaptureProfileResponse, GetCaptureWorkspaceRequest, GetCaptureWorkspaceResponse, GetCompetitiveFieldRequest, GetCompetitiveFieldResponse, GetComplianceObligationsRequest, GetComplianceObligationsResponse, GetCustomerThemeRequest, GetCustomerThemeResponse, GetDocumentSourceScopesRequest, GetDocumentSourceScopesResponse, GetDocumentsRequest, GetDocumentsResponse, GetEntityGraphRequest, GetEntityGraphResponse, GetEventRequest, GetEventResponse, GetFieldLineageRequest, GetFieldLineageResponse, GetGovOrgChartRequest, GetGovOrgChartResponse, GetKeyPersonnelRequest, GetKeyPersonnelResponse, GetLandscapePatternStateRequest, GetLandscapePatternStateResponse, GetLibraryItemRequest, GetLibraryItemResponse, GetMasterMatrixRequest, GetMasterMatrixResponse, GetOpportunityContextRequest, GetOpportunityContextResponse, GetOpportunityWhitespaceAssessmentRequest, GetOpportunityWhitespaceAssessmentResponse, GetOpsAuditByCorrelationRequest, GetOpsAuditByCorrelationResponse, GetPageVisualizationRequest, GetPageVisualizationResponse, GetPreAwardWorkspaceRequest, GetPreAwardWorkspaceResponse, GetPricingRequest, GetPricingResponse, GetProjectChatRequest, GetProjectChatResponse, GetProjectGovConSnapshotRequest, GetProjectGovConSnapshotResponse, GetProjectRequest, GetProjectResponse, GetPursuitGraphRequest, GetPursuitGraphResponse, GetRfiResponseWorkspaceRequest, GetRfiResponseWorkspaceResponse, GetSectionMapRequest, GetSectionMapResponse, GetSectionVersionRequest, GetSectionVersionResponse, GetSolicitationInsightsRequest, GetSolicitationInsightsResponse, GetVolumeDocumentContentRequest, GetVolumeDocumentContentResponse, GetVolumeLegacyTextStateRequest, GetVolumeLegacyTextStateResponse, GetWorkbookVersionRequest, GetWorkbookVersionResponse, ImportProjectDataRequest, ImportProjectDataResponse, ImportSectionRevisionRequest, ImportSectionRevisionResponse, IssueProposalSolicitationVersionRequest, LeaveProjectRequest, LeaveProjectResponse, LinkPursuitRecompeteRequest, LinkPursuitRecompeteResponse, LinkRfiResponseToCaptureRequest, LinkRfiResponseToCaptureResponse, LinkRfiResponseToOpportunityRequest, LinkRfiResponseToOpportunityResponse, LinkRfiResponseToProposalRequest, LinkRfiResponseToProposalResponse, ListCaptureCompetitionLinksRequest, ListCaptureCompetitionLinksResponse, ListCaptureGoNoGoDecisionsRequest, ListCaptureGoNoGoDecisionsResponse, ListCaptureLifecycleEventsRequest, ListCaptureLifecycleEventsResponse, ListCaptureLinksForRfiResponseRequest, ListCaptureLinksForRfiResponseResponse, ListCaptureProjectsRequest, ListCaptureProjectsResponse, ListCaptureTasksRequest, ListCaptureTasksResponse, ListCaptureTeamingLinksRequest, ListCaptureTeamingLinksResponse, ListChangeSetDiscrepanciesRequest, ListChangeSetDiscrepanciesResponse, ListCustomerInteractionsRequest, ListCustomerInteractionsResponse, ListCustomerThemesRequest, ListCustomerThemesResponse, ListDeliverableEvidenceRequest, ListDeliverableEvidenceResponse, ListDraftsRequest, ListDraftsResponse, ListEntityResolutionLogRequest, ListEntityResolutionLogResponse, ListEventsRequest, ListEventsResponse, ListIndirectRatesRequest, ListIndirectRatesResponse, ListMyActivityRequest, ListMyActivityResponse, ListMyProposalAssignedActionsRequest, ListMyProposalAssignedActionsResponse, ListOciFlagsRequest, ListOciFlagsResponse, ListOpportunityContextEvidenceRequest, ListOpportunityContextEvidenceResponse, ListOpportunityLinksForRfiResponseRequest, ListOpportunityLinksForRfiResponseResponse, ListOpsAuditEventsRequest, ListOpsAuditEventsResponse, ListPricingEvidenceRequest, ListPricingEvidenceResponse, ListPricingRequest, ListPricingResponse, ListProgramChangeSetsRequest, ListProgramChangeSetsResponse, ListProjectActivityRequest, ListProjectActivityResponse, ListProjectChatsRequest, ListProjectChatsResponse, ListProjectFilesRequest, ListProjectFilesResponse, ListProjectsRequest, ListProjectsResponse, ListProjectVolumesRequest, ListProjectVolumesResponse, ListProposalLinksForRfiResponseRequest, ListProposalLinksForRfiResponseResponse, ListProposalMilestonesRequest, ListProposalMilestonesResponse, ListProtestWatchesRequest, ListProtestWatchesResponse, ListPublicProtestDecisionsRequest, ListPublicProtestDecisionsResponse, ListPursuitRecompetesRequest, ListPursuitRecompetesResponse, ListPursuitStakeholdersRequest, ListPursuitStakeholdersResponse, ListRfiEventsRequest, ListRfiEventsResponse, ListRfiResponsesForCaptureRequest, ListRfiResponsesForCaptureResponse, ListRfiResponsesForOpportunityRequest, ListRfiResponsesForOpportunityResponse, ListRfiResponsesForProposalRequest, ListRfiResponsesForProposalResponse, ListSectionVersionsRequest, ListSectionVersionsResponse, ListSourceDocumentsRequest, ListSourceDocumentsResponse, ListSourceRefsForTargetRequest, ListSourceRefsForTargetResponse, ListStakeholderAssessmentsRequest, ListStakeholderAssessmentsResponse, ListVolumeDocumentsRequest, ListVolumeDocumentsResponse, ListWorkbookSheetsRequest, ListWorkbookSheetsResponse, ListWorkbookVersionsRequest, ListWorkbookVersionsResponse, ListWorkstreamItemsRequest, ListWorkstreamItemsResponse, LoadTemplateIntoWorkbookRequest, LoadTemplateIntoWorkbookResponse, LoadWorkbookRequest, LoadWorkbookResponse, MapProposalComplianceCoverageRequest, MergeEntityNodesRequest, MergeEntityNodesResponse, NotifyDocumentSavedRequest, NotifyDocumentSavedResponse, OpenOciMitigationRequest, OpenOciMitigationResponse, OpenProtestWatchRequest, OpenProtestWatchResponse, OpenRecompetePursuitRequest, OpenRecompetePursuitResponse, OverrideEntityEdgeRequest, OverrideEntityEdgeResponse, PersistExtractionSourceRefsRequest, PersistExtractionSourceRefsResponse, PreviewDiscardChangeSetRequest, PreviewDiscardChangeSetResponse, ProcessBatchRequest, ProcessBatchResponse, QueryCLINsRequest, QueryCLINsResponse, QueryComplianceRequirementsRequest, QueryComplianceRequirementsResponse, QueryDeliverablesRequest, QueryDeliverablesResponse, QueryLCATsRequest, QueryLCATsResponse, RaiseOciFlagRequest, RaiseOciFlagResponse, ReadProposalComplianceCoverageRequest, ReadProposalSolicitationReviewRequest, RecordCompetitiveFieldAssessmentRequest, RecordCompetitiveFieldAssessmentResponse, RecordCompetitorEvidenceRequest, RecordCompetitorEvidenceResponse, RecordOpportunityWhitespaceAssessmentRequest, RecordOpportunityWhitespaceAssessmentResponse, RecordProposalSolicitationImpactRequest, RecordStakeholderAssessmentRequest, RecordStakeholderAssessmentResponse, RegisterPricingWorkbookRequest, RegisterPricingWorkbookResponse, RelinkProgramDocumentsRequest, RelinkProgramDocumentsResponse, RemeasureOutlineBodiesRequest, RemeasureOutlineBodiesResponse, RemoveMemberRequest, RemoveMemberResponse, RemoveVolumeDocumentRequest, RemoveVolumeDocumentResponse, RenameDraftRequest, RenameDraftResponse, RenameVolumeRequest, RenameVolumeResponse, ReorderProposalVolumesRequest, ReorderProposalVolumesResponse, ReorderVolumeDocumentsRequest, ReorderVolumeDocumentsResponse, ReprocessContractExtractionRequest, ReprocessContractExtractionResponse, ResolveDiscrepancyRequest, ResolveDiscrepancyResponse, ResolvePricingProposalRequest, ResolvePricingProposalResponse, ResolvePursuitEntityRequest, ResolvePursuitEntityResponse, RestoreVersionRequest, RestoreVersionResponse, ResyncExtractedDataRequest, ResyncExtractedDataResponse, ReviewBlackHatInputRequest, ReviewBlackHatInputResponse, ReviseCustomerThemeRequest, ReviseCustomerThemeResponse, RouteDiscrepancyRequest, RouteDiscrepancyResponse, RouteOciFlagRequest, RouteOciFlagResponse, SaveDraftRequest, SaveDraftResponse, SaveLandscapePatternStateRequest, SaveLandscapePatternStateResponse, SaveWorkbookRequest, SaveWorkbookResponse, SearchLibraryItemsRequest, SearchLibraryItemsResponse, SetCapturePlanAreaHealthRequest, SetCapturePlanAreaHealthResponse, SetCaptureTaskPlanAreaRequest, SetCaptureTaskPlanAreaResponse, SetDiscrepancyTargetPeriodRequest, SetDiscrepancyTargetPeriodResponse, SetEventLinkRequest, SetEventLinkResponse, SetOpportunityRfpExpectedRequest, SetOpportunityRfpExpectedResponse, SetPursuitGrowthHintRequest, SetPursuitGrowthHintResponse, SnapshotPricingVersionRequest, SnapshotPricingVersionResponse, StageContractLineItemRequest, StageContractLineItemResponse, StartAwardComparisonRequest, StartAwardComparisonResponse, SubmitPricingWorkbookRevisionRequest, SubmitPricingWorkbookRevisionResponse, SuggestCapturePlanAreaHealthRequest, SuggestCapturePlanAreaHealthResponse, SuggestCustomerThemeRequest, SuggestCustomerThemeResponse, TagProjectFileToOutlineRequest, TagProjectFileToOutlineResponse, TransferOwnershipRequest, TransferOwnershipResponse, UnarchiveProjectRequest, UnarchiveProjectResponse, UnlinkPursuitRecompeteRequest, UnlinkPursuitRecompeteResponse, UnlinkRfiResponseFromCaptureRequest, UnlinkRfiResponseFromCaptureResponse, UnlinkRfiResponseFromOpportunityRequest, UnlinkRfiResponseFromOpportunityResponse, UnlinkRfiResponseFromProposalRequest, UnlinkRfiResponseFromProposalResponse, UnmergeEntityNodesRequest, UnmergeEntityNodesResponse, UpdateActivationGateItemRequest, UpdateActivationGateItemResponse, UpdateCaptureProjectRequest, UpdateCaptureProjectResponse, UpdateCLINRequest, UpdateCLINResponse, UpdateCLINStatusRequest, UpdateCLINStatusResponse, UpdateComplianceStatusRequest, UpdateComplianceStatusResponse, UpdateDeliverableEvidenceRequest, UpdateDeliverableEvidenceResponse, UpdateDeliverableStatusRequest, UpdateDeliverableStatusResponse, UpdateIndirectRateRequest, UpdateIndirectRateResponse, UpdateKeyPersonnelRequest, UpdateKeyPersonnelResponse, UpdateLCATRequest, UpdateLCATResponse, UpdateMemberRoleRequest, UpdateMemberRoleResponse, UpdateOpportunityContextRequest, UpdateOpportunityContextResponse, UpdateOutlineSectionAssignmentsRequest, UpdateOutlineSectionAssignmentsResponse, UpdateOutlineSectionRequest, UpdateOutlineSectionResponse, UpdatePricingRequest, UpdatePricingResponse, UpdateProjectRequest, UpdateProjectResponse, UpdateProtestWatchRequest, UpdateProtestWatchResponse, UpdateRequirementAssignmentRequest, UpdateRequirementAssignmentResponse, UpdateRequirementStatusRequest, UpdateRequirementStatusResponse, UpdateRfiResponseProjectRequest, UpdateRfiResponseProjectResponse, UpdateVolumeDocumentRequest, UpdateVolumeDocumentResponse, UploadProjectFilesRequest, UploadProjectFilesResponse, UpsertBlackHatInputRequest, UpsertBlackHatInputResponse, UpsertCaptureCompetitionLinkRequest, UpsertCaptureCompetitionLinkResponse, UpsertCaptureGoNoGoDecisionRequest, UpsertCaptureGoNoGoDecisionResponse, UpsertCapturePlanAreaRequest, UpsertCapturePlanAreaResponse, UpsertCaptureProfileRequest, UpsertCaptureProfileResponse, UpsertCaptureTaskRequest, UpsertCaptureTaskResponse, UpsertCaptureTeamingLinkRequest, UpsertCaptureTeamingLinkResponse, UpsertCompetitiveFieldParticipantRequest, UpsertCompetitiveFieldParticipantResponse, UpsertCompetitiveFieldStrategyRequest, UpsertCompetitiveFieldStrategyResponse, UpsertCustomerInteractionRequest, UpsertCustomerInteractionResponse, UpsertEntityEdgeRequest, UpsertEntityEdgeResponse, UpsertEntityNodeRequest, UpsertEntityNodeResponse, UpsertEventRequest, UpsertEventResponse, UpsertPreAwardReadinessRequest, UpsertPreAwardReadinessResponse, UpsertProposalMilestoneRequest, UpsertProposalMilestoneResponse, UpsertPursuitStakeholderRequest, UpsertPursuitStakeholderResponse, UpsertRfiEventRequest, UpsertRfiEventResponse, UpsertWorkstreamItemRequest, UpsertWorkstreamItemResponse, UpsertWritingPlanRequest, UpsertWritingPlanResponse } from "./projectdata_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { GetProposalHomeRequest, GetProposalHomeResponse, ListProposalCarriedInRequest, ListProposalCarriedInResponse } from "./proposal_home_pb";
import { GetProposalRecordHeaderRequest, GetProposalRecordHeaderResponse } from "./proposal_record_pb";
import { BringPursuitDocumentsIntoProposalRequest, BringPursuitDocumentsIntoProposalResponse, ListProposalDocumentsRequest, ListProposalDocumentsResponse, RemoveProposalDocumentRequest, RemoveProposalDocumentResponse, UpdateProposalDocumentRequest, UpdateProposalDocumentResponse } from "./proposal_documents_pb";
import { AdoptProposalContextRequest, AdoptProposalContextResponse, CheckProposalContextAccessRequest, CheckProposalContextAccessResponse, DecideProposalContextRequest, DecideProposalContextResponse, GetProposalContextRequest, GetProposalContextResponse, GetProposalContextReviewRequest, GetProposalContextReviewResponse, ListProposalContextCandidatesRequest, ListProposalContextCandidatesResponse, ListProposalContextsRequest, ListProposalContextsResponse } from "./proposal_context_pb";
import { GetGrowthHomeWorkRequest, GetGrowthHomeWorkResponse, ListGrowthWorkspacesRequest, ListGrowthWorkspacesResponse, MarkGrowthHomeSeenRequest, MarkGrowthHomeSeenResponse } from "./growth_home_pb";
import { CreateCaptureOutputHandoffRequest, CreateCaptureOutputHandoffResponse, ExportCaptureOutputRequest, ExportCaptureOutputResponse, GetCaptureOutputPresentationRequest, GetCaptureOutputPresentationResponse, GetCaptureOutputsRequest, GetCaptureOutputsResponse, ListCaptureOutputHandoffsRequest, ListCaptureOutputHandoffsResponse, ListCaptureOutputSnapshotsRequest, ListCaptureOutputSnapshotsResponse, ListCaptureOutputVersionsRequest, ListCaptureOutputVersionsResponse, RecordCaptureOutputDispositionRequest, RecordCaptureOutputDispositionResponse, ReviewCaptureOutputRequest, ReviewCaptureOutputResponse, SaveCaptureOutputMaterialRequest, SaveCaptureOutputMaterialResponse, SaveCaptureOutputPresentationRequest, SaveCaptureOutputPresentationResponse, SaveCaptureOutputSnapshotRequest, SaveCaptureOutputSnapshotResponse, SaveCaptureOutputVersionRequest, SaveCaptureOutputVersionResponse } from "./capture_outputs_pb";
import { GetBlackHatAssessmentHistoryRequest, GetBlackHatAssessmentHistoryResponse, ListBlackHatAssessmentsRequest, ListBlackHatAssessmentsResponse, SaveBlackHatAssessmentVersionRequest, SaveBlackHatAssessmentVersionResponse } from "./black_hat_pb";
import { ConfirmComplianceCoverageResponse, MapComplianceCoverageResponse, ReadComplianceCoverageResponse } from "../../datagateway/v1/proposal_compliance_pb";
import { GetWinThemeHistoryRequest, GetWinThemeHistoryResponse, ListWinThemesRequest, ListWinThemesResponse, SaveWinThemeVersionRequest, SaveWinThemeVersionResponse } from "./win_themes_pb";
import { CaptureProposalReviewResponse, IssueSolicitationVersionResponse, ReadSolicitationReviewResponse, RecordSolicitationImpactResponse } from "../../datagateway/v1/proposal_amendment_pb";
import { CheckPricingAccessRequest, CheckPricingAccessResponse, CheckProposalDocumentAccessRequest, CheckProposalDocumentAccessResponse, RecordPricingActivityRequest, RecordPricingActivityResponse } from "./pricing_access_pb";
import { DecideLcatRegistryLinkRequest, DecideLcatRegistryLinkResponse, PatchPricingScenarioRequest, PatchPricingScenarioResponse, RefreshPricingFromSolicitationRequest, RefreshPricingFromSolicitationResponse, SetPricingRateRequest, SetPricingRateResponse } from "./proposal_pricing_v2_pb";
import { GetPricingRateBookRequest, GetPricingRateBookResponse, GetPricingRateBookRowRequest, GetPricingRateBookRowResponse } from "./proposal_pricing_ratebook_pb";
import { CreateCaptureSolutionHandoffRequest, CreateCaptureSolutionHandoffResponse, GetCaptureSolutionRequest, GetCaptureSolutionResponse, ListCaptureSolutionHandoffsRequest, ListCaptureSolutionHandoffsResponse, RestoreCaptureSolutionRevisionRequest, RestoreCaptureSolutionRevisionResponse, SaveCaptureSolutionRevisionRequest, SaveCaptureSolutionRevisionResponse } from "./capture_solution_pb";
import { GenerateCaptureSolutionSuggestionsRequest, GenerateCaptureSolutionSuggestionsResponse, ListCaptureSolutionSuggestionsRequest, ListCaptureSolutionSuggestionsResponse, ReviewCaptureSolutionSuggestionRequest, ReviewCaptureSolutionSuggestionResponse } from "./capture_solution_suggestions_pb";
import { AddCaptureSolutionAlternativeRequest, AddCaptureSolutionAlternativeResponse, AddCaptureSolutionGapRequest, AddCaptureSolutionGapResponse, DecideCaptureSolutionAlternativeRequest, DecideCaptureSolutionAlternativeResponse, GetCaptureSolutionAlternativesRequest, GetCaptureSolutionAlternativesResponse, ResolveCaptureSolutionGapRequest, ResolveCaptureSolutionGapResponse } from "./capture_solution_alternatives_pb";
import { GetCaptureStaffingRequest, GetCaptureStaffingResponse, SaveCaptureStaffingRevisionRequest, SaveCaptureStaffingRevisionResponse } from "./capture_staffing_pb";
import { GetCaptureStaffingReadinessRequest, GetCaptureStaffingReadinessResponse, SaveCaptureStaffingReadinessRequest, SaveCaptureStaffingReadinessResponse } from "./capture_staffing_readiness_pb";
import { AddCapturePositionCapabilityRequest, AddCapturePositionCapabilityResponse, GetCaptureTeamingPositionRequest, GetCaptureTeamingPositionResponse, ProposeCaptureTeamingCandidateRequest, ProposeCaptureTeamingCandidateResponse, ReviseCaptureTeamingAssessmentRequest, ReviseCaptureTeamingAssessmentResponse, SetCaptureTeamingCandidateStatusRequest, SetCaptureTeamingCandidateStatusResponse } from "./capture_teaming_candidates_pb";
import { AddCaptureTeamingWorkshareRequest, AddCaptureTeamingWorkshareResponse, CreateCaptureTeamingAgreementRequest, CreateCaptureTeamingAgreementResponse, GetCaptureTeamingAgreementsRequest, GetCaptureTeamingAgreementsResponse, SetCaptureTeamingAgreementStateRequest, SetCaptureTeamingAgreementStateResponse } from "./capture_teaming_agreements_pb";
import { GetPursuitHeaderRequest, GetPursuitHeaderResponse, ListPursuitsRequest, ListPursuitsResponse, ListThreadRequest, ListThreadResponse } from "./pursuit_read_pb";
import { DraftTouchpointProposalsRequest, DraftTouchpointProposalsResponse, ListTouchpointProposalsRequest, ListTouchpointProposalsResponse, ReviewTouchpointProposalRequest, ReviewTouchpointProposalResponse } from "./touchpoint_proposals_pb";
import { AcceptNewerOriginRequest, AcceptNewerOriginResponse, AdoptOriginValueRequest, AdoptOriginValueResponse, GetEnrichmentStateRequest, GetEnrichmentStateResponse, ListObservationConflictsRequest, ListObservationConflictsResponse, ListObservationExceptionsRequest, ListObservationExceptionsResponse, ListOriginAdoptionsRequest, ListOriginAdoptionsResponse, RefreshSourceObservationsRequest, RefreshSourceObservationsResponse, ResolveObservationConflictRequest, ResolveObservationConflictResponse, ReverseEnrichmentRequest, ReverseEnrichmentResponse, ReverseObservationResolutionRequest, ReverseObservationResolutionResponse, SetEnrichmentEnabledRequest, SetEnrichmentEnabledResponse } from "./graph_conflicts_pb";
import { ListPursuitSurgeryRequest, ListPursuitSurgeryResponse, MergePursuitsRequest, MergePursuitsResponse, MovePursuitComponentsRequest, MovePursuitComponentsResponse, PlanPursuitSurgeryRequest, PlanPursuitSurgeryResponse, SplitPursuitRequest, SplitPursuitResponse } from "./pursuit_surgery_pb";
/**
 * ProjectDataService provides project-scoped GovCon data access.
 * Hosted by express-backend, consumed by shanks (agent tools).
 *
 * @generated from service mono.projectdata.v1.ProjectDataService
 */ export const ProjectDataService = {
    typeName: "mono.projectdata.v1.ProjectDataService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetLandscapePatternState
     */ getLandscapePatternState: {
            name: "GetLandscapePatternState",
            I: GetLandscapePatternStateRequest,
            O: GetLandscapePatternStateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveLandscapePatternState
     */ saveLandscapePatternState: {
            name: "SaveLandscapePatternState",
            I: SaveLandscapePatternStateRequest,
            O: SaveLandscapePatternStateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetProposalHome
     */ getProposalHome: {
            name: "GetProposalHome",
            I: GetProposalHomeRequest,
            O: GetProposalHomeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProposalCarriedIn
     */ listProposalCarriedIn: {
            name: "ListProposalCarriedIn",
            I: ListProposalCarriedInRequest,
            O: ListProposalCarriedInResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetProposalRecordHeader
     */ getProposalRecordHeader: {
            name: "GetProposalRecordHeader",
            I: GetProposalRecordHeaderRequest,
            O: GetProposalRecordHeaderResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProposalDocuments
     */ listProposalDocuments: {
            name: "ListProposalDocuments",
            I: ListProposalDocumentsRequest,
            O: ListProposalDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateProposalDocument
     */ updateProposalDocument: {
            name: "UpdateProposalDocument",
            I: UpdateProposalDocumentRequest,
            O: UpdateProposalDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RemoveProposalDocument
     */ removeProposalDocument: {
            name: "RemoveProposalDocument",
            I: RemoveProposalDocumentRequest,
            O: RemoveProposalDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.BringPursuitDocumentsIntoProposal
     */ bringPursuitDocumentsIntoProposal: {
            name: "BringPursuitDocumentsIntoProposal",
            I: BringPursuitDocumentsIntoProposalRequest,
            O: BringPursuitDocumentsIntoProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetProposalContextReview
     */ getProposalContextReview: {
            name: "GetProposalContextReview",
            I: GetProposalContextReviewRequest,
            O: GetProposalContextReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DecideProposalContext
     */ decideProposalContext: {
            name: "DecideProposalContext",
            I: DecideProposalContextRequest,
            O: DecideProposalContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AdoptProposalContext
     */ adoptProposalContext: {
            name: "AdoptProposalContext",
            I: AdoptProposalContextRequest,
            O: AdoptProposalContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetProposalContext
     */ getProposalContext: {
            name: "GetProposalContext",
            I: GetProposalContextRequest,
            O: GetProposalContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProposalContexts
     */ listProposalContexts: {
            name: "ListProposalContexts",
            I: ListProposalContextsRequest,
            O: ListProposalContextsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProposalContextCandidates
     */ listProposalContextCandidates: {
            name: "ListProposalContextCandidates",
            I: ListProposalContextCandidatesRequest,
            O: ListProposalContextCandidatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CheckProposalContextAccess
     */ checkProposalContextAccess: {
            name: "CheckProposalContextAccess",
            I: CheckProposalContextAccessRequest,
            O: CheckProposalContextAccessResponse,
            kind: MethodKind.Unary
        },
        /**
     * Answers whether the caller may change a project (add files, documents)
     * the way the UI lets them: PermissionDenied when not. Authorization only;
     * it changes nothing. Chat runs it before publishing on the user's Accept.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CheckProjectWriteAccess
     */ checkProjectWriteAccess: {
            name: "CheckProjectWriteAccess",
            I: CheckProjectWriteAccessRequest,
            O: CheckProjectWriteAccessResponse,
            kind: MethodKind.Unary
        },
        /**
     * Authorized active work; company economics remain owned by PortfolioService.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetGrowthHomeWork
     */ getGrowthHomeWork: {
            name: "GetGrowthHomeWork",
            I: GetGrowthHomeWorkRequest,
            O: GetGrowthHomeWorkResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-02: the Growth RFI-response / Proposal lists. Membership-based by
     * default; tenant-wide when FND-25 rule list.tenant_wide allows the caller.
     * Every row needs project read; linked pursuits need capture_project read.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListGrowthWorkspaces
     */ listGrowthWorkspaces: {
            name: "ListGrowthWorkspaces",
            I: ListGrowthWorkspacesRequest,
            O: ListGrowthWorkspacesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-21: record the caller's Growth Home visit ("changed since" window).
     * Authentication only: it stores the caller's own timestamp.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.MarkGrowthHomeSeen
     */ markGrowthHomeSeen: {
            name: "MarkGrowthHomeSeen",
            I: MarkGrowthHomeSeenRequest,
            O: MarkGrowthHomeSeenResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateCaptureOutputHandoff
     */ createCaptureOutputHandoff: {
            name: "CreateCaptureOutputHandoff",
            I: CreateCaptureOutputHandoffRequest,
            O: CreateCaptureOutputHandoffResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureOutputHandoffs
     */ listCaptureOutputHandoffs: {
            name: "ListCaptureOutputHandoffs",
            I: ListCaptureOutputHandoffsRequest,
            O: ListCaptureOutputHandoffsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListBlackHatAssessments
     */ listBlackHatAssessments: {
            name: "ListBlackHatAssessments",
            I: ListBlackHatAssessmentsRequest,
            O: ListBlackHatAssessmentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveBlackHatAssessmentVersion
     */ saveBlackHatAssessmentVersion: {
            name: "SaveBlackHatAssessmentVersion",
            I: SaveBlackHatAssessmentVersionRequest,
            O: SaveBlackHatAssessmentVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetBlackHatAssessmentHistory
     */ getBlackHatAssessmentHistory: {
            name: "GetBlackHatAssessmentHistory",
            I: GetBlackHatAssessmentHistoryRequest,
            O: GetBlackHatAssessmentHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReadComplianceCoverage
     */ readComplianceCoverage: {
            name: "ReadComplianceCoverage",
            I: ReadProposalComplianceCoverageRequest,
            O: ReadComplianceCoverageResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.MapComplianceCoverage
     */ mapComplianceCoverage: {
            name: "MapComplianceCoverage",
            I: MapProposalComplianceCoverageRequest,
            O: MapComplianceCoverageResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ConfirmComplianceCoverage
     */ confirmComplianceCoverage: {
            name: "ConfirmComplianceCoverage",
            I: ConfirmProposalComplianceCoverageRequest,
            O: ConfirmComplianceCoverageResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureOutputs
     */ getCaptureOutputs: {
            name: "GetCaptureOutputs",
            I: GetCaptureOutputsRequest,
            O: GetCaptureOutputsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveCaptureOutputMaterial
     */ saveCaptureOutputMaterial: {
            name: "SaveCaptureOutputMaterial",
            I: SaveCaptureOutputMaterialRequest,
            O: SaveCaptureOutputMaterialResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveCaptureOutputSnapshot
     */ saveCaptureOutputSnapshot: {
            name: "SaveCaptureOutputSnapshot",
            I: SaveCaptureOutputSnapshotRequest,
            O: SaveCaptureOutputSnapshotResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureOutputSnapshots
     */ listCaptureOutputSnapshots: {
            name: "ListCaptureOutputSnapshots",
            I: ListCaptureOutputSnapshotsRequest,
            O: ListCaptureOutputSnapshotsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureOutputPresentation
     */ getCaptureOutputPresentation: {
            name: "GetCaptureOutputPresentation",
            I: GetCaptureOutputPresentationRequest,
            O: GetCaptureOutputPresentationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveCaptureOutputPresentation
     */ saveCaptureOutputPresentation: {
            name: "SaveCaptureOutputPresentation",
            I: SaveCaptureOutputPresentationRequest,
            O: SaveCaptureOutputPresentationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RecordCaptureOutputDisposition
     */ recordCaptureOutputDisposition: {
            name: "RecordCaptureOutputDisposition",
            I: RecordCaptureOutputDispositionRequest,
            O: RecordCaptureOutputDispositionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ExportCaptureOutput
     */ exportCaptureOutput: {
            name: "ExportCaptureOutput",
            I: ExportCaptureOutputRequest,
            O: ExportCaptureOutputResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReviewCaptureOutput
     */ reviewCaptureOutput: {
            name: "ReviewCaptureOutput",
            I: ReviewCaptureOutputRequest,
            O: ReviewCaptureOutputResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveCaptureOutputVersion
     */ saveCaptureOutputVersion: {
            name: "SaveCaptureOutputVersion",
            I: SaveCaptureOutputVersionRequest,
            O: SaveCaptureOutputVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureOutputVersions
     */ listCaptureOutputVersions: {
            name: "ListCaptureOutputVersions",
            I: ListCaptureOutputVersionsRequest,
            O: ListCaptureOutputVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListWinThemes
     */ listWinThemes: {
            name: "ListWinThemes",
            I: ListWinThemesRequest,
            O: ListWinThemesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveWinThemeVersion
     */ saveWinThemeVersion: {
            name: "SaveWinThemeVersion",
            I: SaveWinThemeVersionRequest,
            O: SaveWinThemeVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetWinThemeHistory
     */ getWinThemeHistory: {
            name: "GetWinThemeHistory",
            I: GetWinThemeHistoryRequest,
            O: GetWinThemeHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * Canonical Opportunity context; tenant/actor and Profile intent are server supplied.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListOpportunityContextEvidence
     */ listOpportunityContextEvidence: {
            name: "ListOpportunityContextEvidence",
            I: ListOpportunityContextEvidenceRequest,
            O: ListOpportunityContextEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetOpportunityContext
     */ getOpportunityContext: {
            name: "GetOpportunityContext",
            I: GetOpportunityContextRequest,
            O: GetOpportunityContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateOpportunityContext
     */ updateOpportunityContext: {
            name: "UpdateOpportunityContext",
            I: UpdateOpportunityContextRequest,
            O: UpdateOpportunityContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-06 (SAD-1124): set or clear "RFP expected" (opportunity update at the
     * tenant root; stale expected_version -> Aborted).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetOpportunityRfpExpected
     */ setOpportunityRfpExpected: {
            name: "SetOpportunityRfpExpected",
            I: SetOpportunityRfpExpectedRequest,
            O: SetOpportunityRfpExpectedResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RecordOpportunityWhitespaceAssessment
     */ recordOpportunityWhitespaceAssessment: {
            name: "RecordOpportunityWhitespaceAssessment",
            I: RecordOpportunityWhitespaceAssessmentRequest,
            O: RecordOpportunityWhitespaceAssessmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetOpportunityWhitespaceAssessment
     */ getOpportunityWhitespaceAssessment: {
            name: "GetOpportunityWhitespaceAssessment",
            I: GetOpportunityWhitespaceAssessmentRequest,
            O: GetOpportunityWhitespaceAssessmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReadSolicitationReview
     */ readSolicitationReview: {
            name: "ReadSolicitationReview",
            I: ReadProposalSolicitationReviewRequest,
            O: ReadSolicitationReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.IssueSolicitationVersion
     */ issueSolicitationVersion: {
            name: "IssueSolicitationVersion",
            I: IssueProposalSolicitationVersionRequest,
            O: IssueSolicitationVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RecordSolicitationImpact
     */ recordSolicitationImpact: {
            name: "RecordSolicitationImpact",
            I: RecordProposalSolicitationImpactRequest,
            O: RecordSolicitationImpactResponse,
            kind: MethodKind.Unary
        },
        /**
     * ======================== Read RPCs ========================
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CaptureProposalReview
     */ captureProposalReview: {
            name: "CaptureProposalReview",
            I: CaptureProposalMaterialReviewRequest,
            O: CaptureProposalReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * Stored project bindings for an Office source. The owning source service
     * separately evaluates each scope; this RPC never grants document access.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetDocumentSourceScopes
     */ getDocumentSourceScopes: {
            name: "GetDocumentSourceScopes",
            I: GetDocumentSourceScopesRequest,
            O: GetDocumentSourceScopesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Full project snapshot with embedded stats across all GovCon entities.
     * Replaces GetProject + GetComplianceStats + GetCLINStats + GetDeliverableStats.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetProjectGovConSnapshot
     */ getProjectGovConSnapshot: {
            name: "GetProjectGovConSnapshot",
            I: GetProjectGovConSnapshotRequest,
            O: GetProjectGovConSnapshotResponse,
            kind: MethodKind.Unary
        },
        /**
     * Source/processed documents only (solicitation, amendments, references).
     * Replaces ListProjectDocuments.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListSourceDocuments
     */ listSourceDocuments: {
            name: "ListSourceDocuments",
            I: ListSourceDocumentsRequest,
            O: ListSourceDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * All project files regardless of processing status.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProjectFiles
     */ listProjectFiles: {
            name: "ListProjectFiles",
            I: ListProjectFilesRequest,
            O: ListProjectFilesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Idempotently register an uploaded attachment in the pangaea artifact plane
     * (artifacts.artifacts) and return the artifact id. Legacy byte-uploaded
     * attachments have no artifact row; this mints one (id == attachment_id,
     * storage_key == the attachment's MinIO key) so delivery program_documents
     * (which FK into artifacts.artifacts) can link the source document. Returns
     * the existing artifact id when one already exists (tesoro artifact_ids mode
     * or a prior call), so re-ingestion never duplicates.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.EnsureArtifactForAttachment
     */ ensureArtifactForAttachment: {
            name: "EnsureArtifactForAttachment",
            I: EnsureArtifactForAttachmentRequest,
            O: EnsureArtifactForAttachmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Query compliance requirements with filters.
     * Replaces QueryComplianceMatrix.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.QueryComplianceRequirements
     */ queryComplianceRequirements: {
            name: "QueryComplianceRequirements",
            I: QueryComplianceRequirementsRequest,
            O: QueryComplianceRequirementsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Query CLINs with filters.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.QueryCLINs
     */ queryCLINs: {
            name: "QueryCLINs",
            I: QueryCLINsRequest,
            O: QueryCLINsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Query labor categories with filters.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.QueryLCATs
     */ queryLCATs: {
            name: "QueryLCATs",
            I: QueryLCATsRequest,
            O: QueryLCATsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Query deliverables with filters.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.QueryDeliverables
     */ queryDeliverables: {
            name: "QueryDeliverables",
            I: QueryDeliverablesRequest,
            O: QueryDeliverablesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Document section hierarchy for a specific document.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateOutlineSectionAssignments
     */ updateOutlineSectionAssignments: {
            name: "UpdateOutlineSectionAssignments",
            I: UpdateOutlineSectionAssignmentsRequest,
            O: UpdateOutlineSectionAssignmentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Caller identity comes from authentication, never request fields. Empty
     * project_id selects all active Proposal projects the caller belongs to.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListMyProposalAssignedActions
     */ listMyProposalAssignedActions: {
            name: "ListMyProposalAssignedActions",
            I: ListMyProposalAssignedActionsRequest,
            O: ListMyProposalAssignedActionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReorderProposalVolumes
     */ reorderProposalVolumes: {
            name: "ReorderProposalVolumes",
            I: ReorderProposalVolumesRequest,
            O: ReorderProposalVolumesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetSectionMap
     */ getSectionMap: {
            name: "GetSectionMap",
            I: GetSectionMapRequest,
            O: GetSectionMapResponse,
            kind: MethodKind.Unary
        },
        /**
     * Amendment tracking — what changed per amendment.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetAmendmentHistory
     */ getAmendmentHistory: {
            name: "GetAmendmentHistory",
            I: GetAmendmentHistoryRequest,
            O: GetAmendmentHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * Flagged ambiguities in contract/solicitation language.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetAmbiguities
     */ getAmbiguities: {
            name: "GetAmbiguities",
            I: GetAmbiguitiesRequest,
            O: GetAmbiguitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a requirement's compliance status and optional mapping.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateRequirementStatus
     */ updateRequirementStatus: {
            name: "UpdateRequirementStatus",
            I: UpdateRequirementStatusRequest,
            O: UpdateRequirementStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * Assign or unassign a requirement to a project member. Pass empty
     * assigned_to_user_id to clear the assignment.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateRequirementAssignment
     */ updateRequirementAssignment: {
            name: "UpdateRequirementAssignment",
            I: UpdateRequirementAssignmentRequest,
            O: UpdateRequirementAssignmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a deliverable's status.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateDeliverableStatus
     */ updateDeliverableStatus: {
            name: "UpdateDeliverableStatus",
            I: UpdateDeliverableStatusRequest,
            O: UpdateDeliverableStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a CLIN's funding status.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateCLINStatus
     */ updateCLINStatus: {
            name: "UpdateCLINStatus",
            I: UpdateCLINStatusRequest,
            O: UpdateCLINStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create or update a proposal outline section.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateOutlineSection
     */ updateOutlineSection: {
            name: "UpdateOutlineSection",
            I: UpdateOutlineSectionRequest,
            O: UpdateOutlineSectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create or update a writing plan for the proposal.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertWritingPlan
     */ upsertWritingPlan: {
            name: "UpsertWritingPlan",
            I: UpsertWritingPlanRequest,
            O: UpsertWritingPlanResponse,
            kind: MethodKind.Unary
        },
        /**
     * Associate a project file with an outline section.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.TagProjectFileToOutline
     */ tagProjectFileToOutline: {
            name: "TagProjectFileToOutline",
            I: TagProjectFileToOutlineRequest,
            O: TagProjectFileToOutlineResponse,
            kind: MethodKind.Unary
        },
        /**
     * Upload files to a project.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UploadProjectFiles
     */ uploadProjectFiles: {
            name: "UploadProjectFiles",
            I: UploadProjectFilesRequest,
            O: UploadProjectFilesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Soft-delete a project file by attachment_id.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteProjectFile
     */ deleteProjectFile: {
            name: "DeleteProjectFile",
            I: DeleteProjectFileRequest,
            O: DeleteProjectFileResponse,
            kind: MethodKind.Unary
        },
        /**
     * List projects for a user/company with filtering and pagination.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProjects
     */ listProjects: {
            name: "ListProjects",
            I: ListProjectsRequest,
            O: ListProjectsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create a new project (general, proposal, or contract).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateProject
     */ createProject: {
            name: "CreateProject",
            I: CreateProjectRequest,
            O: CreateProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get full project details including members and type-specific info.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetProject
     */ getProject: {
            name: "GetProject",
            I: GetProjectRequest,
            O: GetProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update project name/description.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateProject
     */ updateProject: {
            name: "UpdateProject",
            I: UpdateProjectRequest,
            O: UpdateProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * Archive a project.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ArchiveProject
     */ archiveProject: {
            name: "ArchiveProject",
            I: ArchiveProjectRequest,
            O: ArchiveProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * Unarchive a project.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UnarchiveProject
     */ unarchiveProject: {
            name: "UnarchiveProject",
            I: UnarchiveProjectRequest,
            O: UnarchiveProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * Hard-delete a project and all associated data (owner only). Irreversible.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteProject
     */ deleteProject: {
            name: "DeleteProject",
            I: DeleteProjectRequest,
            O: DeleteProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * Add members to a project (max 25 total).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AddMembers
     */ addMembers: {
            name: "AddMembers",
            I: AddMembersRequest,
            O: AddMembersResponse,
            kind: MethodKind.Unary
        },
        /**
     * Remove a member from a project (owner-only, cannot remove owner).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RemoveMember
     */ removeMember: {
            name: "RemoveMember",
            I: RemoveMemberRequest,
            O: RemoveMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a member's role (member/view_only).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateMemberRole
     */ updateMemberRole: {
            name: "UpdateMemberRole",
            I: UpdateMemberRoleRequest,
            O: UpdateMemberRoleResponse,
            kind: MethodKind.Unary
        },
        /**
     * Transfer project ownership to another member.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.TransferOwnership
     */ transferOwnership: {
            name: "TransferOwnership",
            I: TransferOwnershipRequest,
            O: TransferOwnershipResponse,
            kind: MethodKind.Unary
        },
        /**
     * Leave a project (self-removal, owner cannot leave).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.LeaveProject
     */ leaveProject: {
            name: "LeaveProject",
            I: LeaveProjectRequest,
            O: LeaveProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * Computed aggregations from existing shredded requirements.
     * Surfaces page limits, key personnel, deadlines, format rules, security
     * without re-extracting — the shred is the source of truth.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetSolicitationInsights
     */ getSolicitationInsights: {
            name: "GetSolicitationInsights",
            I: GetSolicitationInsightsRequest,
            O: GetSolicitationInsightsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a CLIN's fields.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateCLIN
     */ updateCLIN: {
            name: "UpdateCLIN",
            I: UpdateCLINRequest,
            O: UpdateCLINResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a labor category's fields.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateLCAT
     */ updateLCAT: {
            name: "UpdateLCAT",
            I: UpdateLCATRequest,
            O: UpdateLCATResponse,
            kind: MethodKind.Unary
        },
        /**
     * Delete an outline section.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteOutlineSection
     */ deleteOutlineSection: {
            name: "DeleteOutlineSection",
            I: DeleteOutlineSectionRequest,
            O: DeleteOutlineSectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Query compliance obligations for a contract project.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetComplianceObligations
     */ getComplianceObligations: {
            name: "GetComplianceObligations",
            I: GetComplianceObligationsRequest,
            O: GetComplianceObligationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a compliance obligation's status.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateComplianceStatus
     */ updateComplianceStatus: {
            name: "UpdateComplianceStatus",
            I: UpdateComplianceStatusRequest,
            O: UpdateComplianceStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get key personnel for a contract project.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetKeyPersonnel
     */ getKeyPersonnel: {
            name: "GetKeyPersonnel",
            I: GetKeyPersonnelRequest,
            O: GetKeyPersonnelResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a key personnel record.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateKeyPersonnel
     */ updateKeyPersonnel: {
            name: "UpdateKeyPersonnel",
            I: UpdateKeyPersonnelRequest,
            O: UpdateKeyPersonnelResponse,
            kind: MethodKind.Unary
        },
        /**
     * List chats for a project.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProjectChats
     */ listProjectChats: {
            name: "ListProjectChats",
            I: ListProjectChatsRequest,
            O: ListProjectChatsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get a single project chat with message count.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetProjectChat
     */ getProjectChat: {
            name: "GetProjectChat",
            I: GetProjectChatRequest,
            O: GetProjectChatResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create a new chat in a project.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateProjectChat
     */ createProjectChat: {
            name: "CreateProjectChat",
            I: CreateProjectChatRequest,
            O: CreateProjectChatResponse,
            kind: MethodKind.Unary
        },
        /**
     * Fork an existing project chat (deep copy messages).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ForkProjectChat
     */ forkProjectChat: {
            name: "ForkProjectChat",
            I: ForkProjectChatRequest,
            O: ForkProjectChatResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get the master compliance matrix with amendment tracking.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetMasterMatrix
     */ getMasterMatrix: {
            name: "GetMasterMatrix",
            I: GetMasterMatrixRequest,
            O: GetMasterMatrixResponse,
            kind: MethodKind.Unary
        },
        /**
     * List pricing scenarios for a project.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListPricing
     */ listPricing: {
            name: "ListPricing",
            I: ListPricingRequest,
            O: ListPricingResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get a single pricing scenario.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetPricing
     */ getPricing: {
            name: "GetPricing",
            I: GetPricingRequest,
            O: GetPricingResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create a pricing scenario.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreatePricing
     */ createPricing: {
            name: "CreatePricing",
            I: CreatePricingRequest,
            O: CreatePricingResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a pricing scenario.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdatePricing
     */ updatePricing: {
            name: "UpdatePricing",
            I: UpdatePricingRequest,
            O: UpdatePricingResponse,
            kind: MethodKind.Unary
        },
        /**
     * Delete a pricing scenario.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeletePricing
     */ deletePricing: {
            name: "DeletePricing",
            I: DeletePricingRequest,
            O: DeletePricingResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-529 reproducible pricing evidence. Reads need project membership,
     * writes need project write access (same gates as the pricing RPCs above).
     * List a scenario's snapshots, workbooks, reconciliation proposals and live
     * Rate Book selections.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListPricingEvidence
     */ listPricingEvidence: {
            name: "ListPricingEvidence",
            I: ListPricingEvidenceRequest,
            O: ListPricingEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * Freeze the scenario (data, items, pinned Rate Book selections) as a new version.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SnapshotPricingVersion
     */ snapshotPricingVersion: {
            name: "SnapshotPricingVersion",
            I: SnapshotPricingVersionRequest,
            O: SnapshotPricingVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Attach a workbook document; no mapping_json means document evidence only.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RegisterPricingWorkbook
     */ registerPricingWorkbook: {
            name: "RegisterPricingWorkbook",
            I: RegisterPricingWorkbookRequest,
            O: RegisterPricingWorkbookResponse,
            kind: MethodKind.Unary
        },
        /**
     * Record a revised workbook; a mapped one yields a PENDING proposal.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SubmitPricingWorkbookRevision
     */ submitPricingWorkbookRevision: {
            name: "SubmitPricingWorkbookRevision",
            I: SubmitPricingWorkbookRevisionRequest,
            O: SubmitPricingWorkbookRevisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Accept (apply + new snapshot) or reject a pending proposal.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ResolvePricingProposal
     */ resolvePricingProposal: {
            name: "ResolvePricingProposal",
            I: ResolvePricingProposalRequest,
            O: ResolvePricingProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CheckPricingAccess
     */ checkPricingAccess: {
            name: "CheckPricingAccess",
            I: CheckPricingAccessRequest,
            O: CheckPricingAccessResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CheckProposalDocumentAccess
     */ checkProposalDocumentAccess: {
            name: "CheckProposalDocumentAccess",
            I: CheckProposalDocumentAccessRequest,
            O: CheckProposalDocumentAccessResponse,
            kind: MethodKind.Unary
        },
        /**
     * Internal lane only: called by ryugu with the end user's identity forwarded. Records one
     * project activity row after a successful rate pin; re-checks pricing write authority.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RecordPricingActivity
     */ recordPricingActivity: {
            name: "RecordPricingActivity",
            I: RecordPricingActivityRequest,
            O: RecordPricingActivityResponse,
            kind: MethodKind.Unary
        },
        /**
     * PRP-11: re-sync pricing scenarios from Section B (new/removed/retitled LCATs, CLIN periods)
     * and refresh the LCAT -> registry links. Never changes a rate a person set. Writer gate.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RefreshPricingFromSolicitation
     */ refreshPricingFromSolicitation: {
            name: "RefreshPricingFromSolicitation",
            I: RefreshPricingFromSolicitationRequest,
            O: RefreshPricingFromSolicitationResponse,
            kind: MethodKind.Unary
        },
        /**
     * PRP-12: the Rate Book on the rate card: Ours / Teammate / Competitor evidence, the sourced
     * Suggested (rules S0-S7), Using and the team adjustment, per category for one period. Read
     * gate; the Rate Book columns need ABAC rule ratebook.columns.read.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetPricingRateBook
     */ getPricingRateBook: {
            name: "GetPricingRateBook",
            I: GetPricingRateBookRequest,
            O: GetPricingRateBookResponse,
            kind: MethodKind.Unary
        },
        /**
     * PRP-12: one rate-card row with its whole observation rail and recent history.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetPricingRateBookRow
     */ getPricingRateBookRow: {
            name: "GetPricingRateBookRow",
            I: GetPricingRateBookRowRequest,
            O: GetPricingRateBookRowResponse,
            kind: MethodKind.Unary
        },
        /**
     * PRP-13: set or clear one Using rate with its reason (S6) and, for an observation, its pin, in one
     * transaction. Writer gate; one pricing_rate activity row.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetPricingRate
     */ setPricingRate: {
            name: "SetPricingRate",
            I: SetPricingRateRequest,
            O: SetPricingRateResponse,
            kind: MethodKind.Unary
        },
        /**
     * PRP-13: autosave. Allow-listed JSON-pointer ops with a compare-and-set on updated_at
     * (FailedPrecondition on conflict, nothing written). Rate-card rates are refused: use SetPricingRate.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.PatchPricingScenario
     */ patchPricingScenario: {
            name: "PatchPricingScenario",
            I: PatchPricingScenarioRequest,
            O: PatchPricingScenarioResponse,
            kind: MethodKind.Unary
        },
        /**
     * PRP-13: decide an LCAT's registry link. A reason is required.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DecideLcatRegistryLink
     */ decideLcatRegistryLink: {
            name: "DecideLcatRegistryLink",
            I: DecideLcatRegistryLinkRequest,
            O: DecideLcatRegistryLinkResponse,
            kind: MethodKind.Unary
        },
        /**
     * List company indirect rate configs.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListIndirectRates
     */ listIndirectRates: {
            name: "ListIndirectRates",
            I: ListIndirectRatesRequest,
            O: ListIndirectRatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create a company indirect rate config.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateIndirectRate
     */ createIndirectRate: {
            name: "CreateIndirectRate",
            I: CreateIndirectRateRequest,
            O: CreateIndirectRateResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a company indirect rate config.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateIndirectRate
     */ updateIndirectRate: {
            name: "UpdateIndirectRate",
            I: UpdateIndirectRateRequest,
            O: UpdateIndirectRateResponse,
            kind: MethodKind.Unary
        },
        /**
     * Delete a company indirect rate config.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteIndirectRate
     */ deleteIndirectRate: {
            name: "DeleteIndirectRate",
            I: DeleteIndirectRateRequest,
            O: DeleteIndirectRateResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get processed documents with status and classification.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetDocuments
     */ getDocuments: {
            name: "GetDocuments",
            I: GetDocumentsRequest,
            O: GetDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get page visualization data (blocks) for a specific document page.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetPageVisualization
     */ getPageVisualization: {
            name: "GetPageVisualization",
            I: GetPageVisualizationRequest,
            O: GetPageVisualizationResponse,
            kind: MethodKind.Unary
        },
        /**
     * Trigger batch document processing for a project.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ProcessBatch
     */ processBatch: {
            name: "ProcessBatch",
            I: ProcessBatchRequest,
            O: ProcessBatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get batch processing status.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetBatchStatus
     */ getBatchStatus: {
            name: "GetBatchStatus",
            I: GetBatchStatusRequest,
            O: GetBatchStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * Re-link a project's documents into its already-created delivery program's
     * Docs tab, without re-running extraction. The proportional recovery for a
     * program_docs_incomplete batch (some Docs rows failed to link) — it re-runs
     * only the link loop, not baltigo + classification + LLM extraction.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RelinkProgramDocuments
     */ relinkProgramDocuments: {
            name: "RelinkProgramDocuments",
            I: RelinkProgramDocumentsRequest,
            O: RelinkProgramDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Dev-only: re-sync extracted data from MinIO → zou DB without re-extracting.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ResyncExtractedData
     */ resyncExtractedData: {
            name: "ResyncExtractedData",
            I: ResyncExtractedDataRequest,
            O: ResyncExtractedDataResponse,
            kind: MethodKind.Unary
        },
        /**
     * Re-run contract extraction stages (AnalyzeContract → CLINs → program sync)
     * against already-converted MinIO artifacts — skips PDF conversion.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReprocessContractExtraction
     */ reprocessContractExtraction: {
            name: "ReprocessContractExtraction",
            I: ReprocessContractExtractionRequest,
            O: ReprocessContractExtractionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create a contract project from an existing proposal project,
     * carrying over extracted data (requirements, CLINs, deliverables).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateContractProjectFromProposal
     */ createContractProjectFromProposal: {
            name: "CreateContractProjectFromProposal",
            I: CreateContractProjectFromProposalRequest,
            O: CreateContractProjectFromProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * Ensure a delivery program backs the contract project: returns the
     * existing program when one resolves (directly or via a converged
     * binding), otherwise creates a placeholder keyed by the project —
     * the manual door for contract projects that predate creation-time
     * attachment or whose award has not been processed yet.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.EnsureDeliveryProgram
     */ ensureDeliveryProgram: {
            name: "EnsureDeliveryProgram",
            I: EnsureDeliveryProgramRequest,
            O: EnsureDeliveryProgramResponse,
            kind: MethodKind.Unary
        },
        /**
     * Import a full project with all related entities from MongoDB.
     * Idempotent: returns already_existed=true if projectId is already present.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ImportProjectData
     */ importProjectData: {
            name: "ImportProjectData",
            I: ImportProjectDataRequest,
            O: ImportProjectDataResponse,
            kind: MethodKind.Unary
        },
        /**
     * Unified activity feed for a project. UNIONs RequirementStatusHistory
     * and AuditLog entries scoped to the project, ordered by changed_at DESC.
     * Powers the V2 Home page "recent activity" panel.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProjectActivity
     */ listProjectActivity: {
            name: "ListProjectActivity",
            I: ListProjectActivityRequest,
            O: ListProjectActivityResponse,
            kind: MethodKind.Unary
        },
        /**
     * List the canonical proposal volumes for a project. Returns the merged
     * set of insights-pipeline volumes and any user-created custom volumes,
     * mapped through the project_volumes table for stable UUIDs across
     * reprocessing.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProjectVolumes
     */ listProjectVolumes: {
            name: "ListProjectVolumes",
            I: ListProjectVolumesRequest,
            O: ListProjectVolumesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create a custom (user-defined) project volume.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateCustomVolume
     */ createCustomVolume: {
            name: "CreateCustomVolume",
            I: CreateCustomVolumeRequest,
            O: CreateCustomVolumeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Soft-delete a custom volume. Insights-derived volumes cannot be
     * deleted via this RPC; they are managed by the sync pipeline.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteCustomVolume
     */ deleteCustomVolume: {
            name: "DeleteCustomVolume",
            I: DeleteCustomVolumeRequest,
            O: DeleteCustomVolumeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Rename a project volume's display name. Works on both custom and
     * insights-derived volumes; the rename persists across reprocessing.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RenameVolume
     */ renameVolume: {
            name: "RenameVolume",
            I: RenameVolumeRequest,
            O: RenameVolumeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Add a document to a volume. Creates a shirohige document (blank or
     * from a source attachment template) and links it via VolumeDocument.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AddVolumeDocument
     */ addVolumeDocument: {
            name: "AddVolumeDocument",
            I: AddVolumeDocumentRequest,
            O: AddVolumeDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Remove a document from a volume. Soft-deletes the VolumeDocument row.
     * Does NOT delete the shirohige document.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RemoveVolumeDocument
     */ removeVolumeDocument: {
            name: "RemoveVolumeDocument",
            I: RemoveVolumeDocumentRequest,
            O: RemoveVolumeDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * List all documents for a volume.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListVolumeDocuments
     */ listVolumeDocuments: {
            name: "ListVolumeDocuments",
            I: ListVolumeDocumentsRequest,
            O: ListVolumeDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a volume document's label or submission filename.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateVolumeDocument
     */ updateVolumeDocument: {
            name: "UpdateVolumeDocument",
            I: UpdateVolumeDocumentRequest,
            O: UpdateVolumeDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Reorder documents within a volume (controls merge order for submission).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReorderVolumeDocuments
     */ reorderVolumeDocuments: {
            name: "ReorderVolumeDocuments",
            I: ReorderVolumeDocumentsRequest,
            O: ReorderVolumeDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Notify zou that a shirohige document was saved. Shirohige calls this
     * after a successful OnlyOffice save callback. Zou looks up which volume
     * the document belongs to, calls baltigo ExtractOutline, and syncs the
     * OutlineSection rows. Fire-and-forget — errors don't block the save.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.NotifyDocumentSaved
     */ notifyDocumentSaved: {
            name: "NotifyDocumentSaved",
            I: NotifyDocumentSavedRequest,
            O: NotifyDocumentSavedResponse,
            kind: MethodKind.Unary
        },
        /**
     * PRP-31: re-measure outline section bodies (outline_sections.body_chars)
     * from each live volume main document's current bytes. Run once per
     * deployment after migration 004616. Operator-only: a direct in-cluster
     * call with no identity headers; any principal (browser lane included,
     * role-less or not) is refused. Writes nothing but the
     * body measure; repeating it on unchanged documents writes the same values.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RemeasureOutlineBodies
     */ remeasureOutlineBodies: {
            name: "RemeasureOutlineBodies",
            I: RemeasureOutlineBodiesRequest,
            O: RemeasureOutlineBodiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Read the text content of a volume document. Zou looks up the document
     * in shirohige/MinIO, calls baltigo to extract text, returns it.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetVolumeDocumentContent
     */ getVolumeDocumentContent: {
            name: "GetVolumeDocumentContent",
            I: GetVolumeDocumentContentRequest,
            O: GetVolumeDocumentContentResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-1202 (WRT-22): which sections of a volume still hold legacy TipTap
     * text (a Main draft or any version with non-blank text), so the UI never
     * hides it. orphan_text_count is the project's Main drafts with text whose
     * section is no longer in the outline. Read-only.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetVolumeLegacyTextState
     */ getVolumeLegacyTextState: {
            name: "GetVolumeLegacyTextState",
            I: GetVolumeLegacyTextStateRequest,
            O: GetVolumeLegacyTextStateResponse,
            kind: MethodKind.Unary
        },
        /**
     * Save draft content (autosave). Creates the draft if it doesn't exist.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveDraft
     */ saveDraft: {
            name: "SaveDraft",
            I: SaveDraftRequest,
            O: SaveDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * List all drafts for a section.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListDrafts
     */ listDrafts: {
            name: "ListDrafts",
            I: ListDraftsRequest,
            O: ListDraftsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create a new named draft (optionally forked from an existing draft or version).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateDraft
     */ createDraft: {
            name: "CreateDraft",
            I: CreateDraftRequest,
            O: CreateDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * Delete a draft.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteDraft
     */ deleteDraft: {
            name: "DeleteDraft",
            I: DeleteDraftRequest,
            O: DeleteDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * Rename a draft.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RenameDraft
     */ renameDraft: {
            name: "RenameDraft",
            I: RenameDraftRequest,
            O: RenameDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * Commit a draft — creates an immutable SectionVersion snapshot.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CommitDraft
     */ commitDraft: {
            name: "CommitDraft",
            I: CommitDraftRequest,
            O: CommitDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * Restore a committed version into a draft.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RestoreVersion
     */ restoreVersion: {
            name: "RestoreVersion",
            I: RestoreVersionRequest,
            O: RestoreVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * List committed versions for a section.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListSectionVersions
     */ listSectionVersions: {
            name: "ListSectionVersions",
            I: ListSectionVersionsRequest,
            O: ListSectionVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get full content of a specific version (for diff rendering).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetSectionVersion
     */ getSectionVersion: {
            name: "GetSectionVersion",
            I: GetSectionVersionRequest,
            O: GetSectionVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Lock the section's head content as a formal review snapshot.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateReviewSnapshot
     */ createReviewSnapshot: {
            name: "CreateReviewSnapshot",
            I: CreateReviewSnapshotRequest,
            O: CreateReviewSnapshotResponse,
            kind: MethodKind.Unary
        },
        /**
     * Two versions of a section side by side, with the line diff between them.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CompareSectionVersions
     */ compareSectionVersions: {
            name: "CompareSectionVersions",
            I: CompareSectionVersionsRequest,
            O: CompareSectionVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Bring a revised document in as a new version with its provenance.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ImportSectionRevision
     */ importSectionRevision: {
            name: "ImportSectionRevision",
            I: ImportSectionRevisionRequest,
            O: ImportSectionRevisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Load a gov-provided XLSX template into a workbook volume (copies to MinIO).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.LoadTemplateIntoWorkbook
     */ loadTemplateIntoWorkbook: {
            name: "LoadTemplateIntoWorkbook",
            I: LoadTemplateIntoWorkbookRequest,
            O: LoadTemplateIntoWorkbookResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get the latest workbook XLSX bytes for rendering in the frontend.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.LoadWorkbook
     */ loadWorkbook: {
            name: "LoadWorkbook",
            I: LoadWorkbookRequest,
            O: LoadWorkbookResponse,
            kind: MethodKind.Unary
        },
        /**
     * Save workbook — receives XLSX bytes, writes to MinIO, creates new version.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveWorkbook
     */ saveWorkbook: {
            name: "SaveWorkbook",
            I: SaveWorkbookRequest,
            O: SaveWorkbookResponse,
            kind: MethodKind.Unary
        },
        /**
     * List workbook version history (metadata only, no file content).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListWorkbookVersions
     */ listWorkbookVersions: {
            name: "ListWorkbookVersions",
            I: ListWorkbookVersionsRequest,
            O: ListWorkbookVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get a specific workbook version's XLSX bytes (for diff or restore).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetWorkbookVersion
     */ getWorkbookVersion: {
            name: "GetWorkbookVersion",
            I: GetWorkbookVersionRequest,
            O: GetWorkbookVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * List sheet names for a workbook volume (lightweight, from DB cache).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListWorkbookSheets
     */ listWorkbookSheets: {
            name: "ListWorkbookSheets",
            I: ListWorkbookSheetsRequest,
            O: ListWorkbookSheetsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Diff two workbook versions — returns cell-level changes.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DiffWorkbookVersions
     */ diffWorkbookVersions: {
            name: "DiffWorkbookVersions",
            I: DiffWorkbookVersionsRequest,
            O: DiffWorkbookVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Freeze the submitted proposal's bid baseline, create the PreAwardProject
     * row in pangaea, and spawn a new zou Project (type=pre_award) linked
     * back to the proposal. Rejects if the source project isn't a proposal.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ConvertProposalToPreAward
     */ convertProposalToPreAward: {
            name: "ConvertProposalToPreAward",
            I: ConvertProposalToPreAwardRequest,
            O: ConvertProposalToPreAwardResponse,
            kind: MethodKind.Unary
        },
        /**
     * Spawn a new zou Project (type=proposal) from a Capture Project when a
     * solicitation appears (vision §10). The proposal links back to its source
     * capture via source_capture_project_id (carry-forward by reference — the
     * capture's RFIs/interactions/workstreams/graph stay in pangaea govcon),
     * and the capture is marked stage=converted. Idempotent per source capture.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ConvertCaptureToProposal
     */ convertCaptureToProposal: {
            name: "ConvertCaptureToProposal",
            I: ConvertCaptureToProposalRequest,
            O: ConvertCaptureToProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * Upsert one of the 8 SDS §3.3 readiness areas
     * (Staffing|Financial|Subcontractor|Schedule|Governance|Customer|Artifacts|Risk).
     * Keyed on (pre_award_project_id, area).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertPreAwardReadiness
     */ upsertPreAwardReadiness: {
            name: "UpsertPreAwardReadiness",
            I: UpsertPreAwardReadinessRequest,
            O: UpsertPreAwardReadinessResponse,
            kind: MethodKind.Unary
        },
        /**
     * Read a Pre-Award workspace summary (PreAwardProject + 8 readiness rows).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetPreAwardWorkspace
     */ getPreAwardWorkspace: {
            name: "GetPreAwardWorkspace",
            I: GetPreAwardWorkspaceRequest,
            O: GetPreAwardWorkspaceResponse,
            kind: MethodKind.Unary
        },
        /**
     * BeginAwardComparison runs the SDS §4 comparison engine against the
     * frozen bid baseline + the 8 readiness rows + the supplied awarded
     * contract data, persists an AwardImportChangeSet + draft discrepancies
     * in pangaea, and returns a summary the UI can route to. Cancels any
     * prior Draft/UnderReview change-set for the same pre-award before
     * creating the new one (history preserved on the cancelled row).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.BeginAwardComparison
     */ beginAwardComparison: {
            name: "BeginAwardComparison",
            I: BeginAwardComparisonRequest,
            O: BeginAwardComparisonResponse,
            kind: MethodKind.Unary
        },
        /**
     * Cold document extraction runs independently of the browser request.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.StartAwardComparison
     */ startAwardComparison: {
            name: "StartAwardComparison",
            I: StartAwardComparisonRequest,
            O: StartAwardComparisonResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetAwardComparisonRun
     */ getAwardComparisonRun: {
            name: "GetAwardComparisonRun",
            I: GetAwardComparisonRunRequest,
            O: GetAwardComparisonRunResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CancelAwardComparisonRun
     */ cancelAwardComparisonRun: {
            name: "CancelAwardComparisonRun",
            I: CancelAwardComparisonRunRequest,
            O: CancelAwardComparisonRunResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetBidBaseline returns the frozen proposal snapshot a Pre-Award
     * workspace was promoted from, projected into a browser-friendly
     * read-only view (timestamps pre-formatted, no protobuf Timestamp).
     * Scoped on the owning pre-award (pre_award_project:read); the baseline
     * id is resolved from that row, so callers never address a baseline
     * outside their pre-award. The frozen snapshot lives in pangaea — zou
     * proxies it so the browser reaches it through the same ProjectDataService
     * surface as the rest of the workspace.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetBidBaseline
     */ getBidBaseline: {
            name: "GetBidBaseline",
            I: GetBidBaselineRequest,
            O: GetBidBaselineResponse,
            kind: MethodKind.Unary
        },
        /**
     * List the discrepancies for a single change-set in canonical order
     * (comparison_area first, severity descending within an area). Drives
     * the Award Comparison workspace table.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListChangeSetDiscrepancies
     */ listChangeSetDiscrepancies: {
            name: "ListChangeSetDiscrepancies",
            I: ListChangeSetDiscrepanciesRequest,
            O: ListChangeSetDiscrepanciesResponse,
            kind: MethodKind.Unary
        },
        /**
     * ResolveDiscrepancy records the reviewer's decision (Accepted,
     * Corrected, Clarified, Waived, Rejected, Escalated, Resolved) on a
     * single DiscrepancyRecord row. Authorised via Cerbos
     * `discrepancy:resolve` — see services/enies-lobby/policies/
     * discrepancy_policy.yaml. The handler gates on the
     * `is_functional_owner` derived role, which fires when the principal's
     * `function` claim overlaps with the discrepancy's functional_owner.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ResolveDiscrepancy
     */ resolveDiscrepancy: {
            name: "ResolveDiscrepancy",
            I: ResolveDiscrepancyRequest,
            O: ResolveDiscrepancyResponse,
            kind: MethodKind.Unary
        },
        /**
     * RouteDiscrepancy reassigns a discrepancy to a different functional
     * area without recording a decision. Used when the comparison engine
     * mis-routed a row or when triage realises the work belongs elsewhere.
     * Authorised via Cerbos `discrepancy:route`.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RouteDiscrepancy
     */ routeDiscrepancy: {
            name: "RouteDiscrepancy",
            I: RouteDiscrepancyRequest,
            O: RouteDiscrepancyResponse,
            kind: MethodKind.Unary
        },
        /**
     * SetDiscrepancyTargetPeriod lets the reviewer pick which contract period a
     * PeriodOfPerformance discrepancy applies to when extraction left the target
     * empty (SAD-395). Authorised via Cerbos `discrepancy:resolve`; delegates to
     * pangaea SetContractChangeItemTarget, which validates the period belongs to
     * the change set's program.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetDiscrepancyTargetPeriod
     */ setDiscrepancyTargetPeriod: {
            name: "SetDiscrepancyTargetPeriod",
            I: SetDiscrepancyTargetPeriodRequest,
            O: SetDiscrepancyTargetPeriodResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- OCI safe lane (Phase 3a) --------
     * RaiseOciFlag opens a conflict-of-interest flag on a project from a graph /
     * prior-work / vehicle signal (or manually). RouteOciFlag reassigns it to a
     * functional owner (same SDS roster + validation as RouteDiscrepancy).
     * DecideOciFlag records a cleared|waived decision with a reason.
     * OpenOciMitigation records the firewall plan (restricted users/artifacts)
     * that 3a-4 maps onto authz enforcement. Each mutation emits an ops-audit
     * event; all delegate to pangaea's ComplianceGatewayService.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RaiseOciFlag
     */ raiseOciFlag: {
            name: "RaiseOciFlag",
            I: RaiseOciFlagRequest,
            O: RaiseOciFlagResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RouteOciFlag
     */ routeOciFlag: {
            name: "RouteOciFlag",
            I: RouteOciFlagRequest,
            O: RouteOciFlagResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DecideOciFlag
     */ decideOciFlag: {
            name: "DecideOciFlag",
            I: DecideOciFlagRequest,
            O: DecideOciFlagResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListOciFlags
     */ listOciFlags: {
            name: "ListOciFlags",
            I: ListOciFlagsRequest,
            O: ListOciFlagsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.OpenOciMitigation
     */ openOciMitigation: {
            name: "OpenOciMitigation",
            I: OpenOciMitigationRequest,
            O: OpenOciMitigationResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Protest safe lane (Phase 3b) --------
     * OpenProtestWatch computes the 10-day awareness window (debrief + 10 days)
     * server-side. AddPublicProtestDecision attaches a PUBLIC GAO decision to a
     * watch for pattern study. Each mutation emits an ops-audit event.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.OpenProtestWatch
     */ openProtestWatch: {
            name: "OpenProtestWatch",
            I: OpenProtestWatchRequest,
            O: OpenProtestWatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateProtestWatch
     */ updateProtestWatch: {
            name: "UpdateProtestWatch",
            I: UpdateProtestWatchRequest,
            O: UpdateProtestWatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProtestWatches
     */ listProtestWatches: {
            name: "ListProtestWatches",
            I: ListProtestWatchesRequest,
            O: ListProtestWatchesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AddPublicProtestDecision
     */ addPublicProtestDecision: {
            name: "AddPublicProtestDecision",
            I: AddPublicProtestDecisionRequest,
            O: AddPublicProtestDecisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListPublicProtestDecisions
     */ listPublicProtestDecisions: {
            name: "ListPublicProtestDecisions",
            I: ListPublicProtestDecisionsRequest,
            O: ListPublicProtestDecisionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * CommitImport finalises the AwardComparison: validates every
     * discrepancy is non-Open and every Blocking row is Resolved or
     * Waived, creates the Contract Project (pangaea Program row) and
     * prepopulates the canonical ContractInfo fields with field_lineage,
     * seeds the 15-item activation gate, then flips the change-set state
     * to Applied + links it to the new contract project. Authorised via
     * Cerbos `change_set:commit` (admin only by default — see
     * change_set_policy.yaml).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CommitImport
     */ commitImport: {
            name: "CommitImport",
            I: CommitImportRequest,
            O: CommitImportResponse,
            kind: MethodKind.Unary
        },
        /**
     * BeginModificationComparison (Phase 4d) turns a deterministic
     * ParsedModificationV2 (from baltigo.AnalyzeModificationV2) into a
     * Modification ContractChangeSet + its field-level ContractChangeItem rows,
     * linked to the EXISTING contract Program. No comparison engine: the V2
     * extraction already carries the old->new deltas. Cancels any prior in-flight
     * Modification change-set for the same program before creating the new one.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.BeginModificationComparison
     */ beginModificationComparison: {
            name: "BeginModificationComparison",
            I: BeginModificationComparisonRequest,
            O: BeginModificationComparisonResponse,
            kind: MethodKind.Unary
        },
        /**
     * CommitModification finalises a Modification change-set: validates every item
     * is settled (Blocking rows affirmatively disposed), then applies it
     * transactionally against the already-linked Program via pangaea
     * ApplyChangeSet. Unlike CommitImport it creates no Program and seeds no
     * activation gate (both already exist on the contract). Cerbos change_set:commit.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CommitModification
     */ commitModification: {
            name: "CommitModification",
            I: CommitModificationRequest,
            O: CommitModificationResponse,
            kind: MethodKind.Unary
        },
        /**
     * DiscardChangeSet ends a Modification, ReExtraction, ContractIntake or
     * AwardImport set that has not been applied: Cancelled with the reviewer's
     * required reason, its open items closed, and an audit event on the
     * program's history (pangaea DiscardContractChangeSet). An Applied set is
     * refused. remove_document also deletes the uploaded document behind the
     * set when nothing else references it. Whoever may commit the set may
     * discard it (requireChangeSetContractsAuthority; an award set adds
     * create_program, as CommitImport does).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DiscardChangeSet
     */ discardChangeSet: {
            name: "DiscardChangeSet",
            I: DiscardChangeSetRequest,
            O: DiscardChangeSetResponse,
            kind: MethodKind.Unary
        },
        /**
     * PreviewDiscardChangeSet answers, without writing, whether the caller may
     * discard the set and whether its uploaded document can be removed with
     * it, naming what still references the document when it cannot.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.PreviewDiscardChangeSet
     */ previewDiscardChangeSet: {
            name: "PreviewDiscardChangeSet",
            I: PreviewDiscardChangeSetRequest,
            O: PreviewDiscardChangeSetResponse,
            kind: MethodKind.Unary
        },
        /**
     * StageContractLineItem (SAD-768) appends a reviewer-authored "Add a missing
     * line" or "Correct this line" review item onto an open ContractIntake or
     * Modification change set. Money is not written until the set is applied.
     * A duplicate CLIN number on Add returns FailedPrecondition with
     * redirect_to_correct set so the UI offers Correct instead. Cerbos
     * change_set:commit (same door as ResolveDiscrepancy).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.StageContractLineItem
     */ stageContractLineItem: {
            name: "StageContractLineItem",
            I: StageContractLineItemRequest,
            O: StageContractLineItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListProgramChangeSets lists the change-sets attached to a contract Program
     * (optionally filtered by change_set_type, e.g. "Modification"), newest first.
     * Drives the Modification Center roster. Proxies pangaea ListContractChangeSets.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProgramChangeSets
     */ listProgramChangeSets: {
            name: "ListProgramChangeSets",
            I: ListProgramChangeSetsRequest,
            O: ListProgramChangeSetsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetActivationGate returns the 15-item gate seeded by CommitImport
     * alongside its parent ContractActivationGate row. View-only; gated
     * by Cerbos `activation_gate:read`.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetActivationGate
     */ getActivationGate: {
            name: "GetActivationGate",
            I: GetActivationGateRequest,
            O: GetActivationGateResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateActivationGateItem flips a single gate item between
     * Pending|Complete|Waived. Reason is required for Waived. The handler
     * re-loads the gate after the write so the caller renders the freshly
     * computed "ready to activate" boolean without a second round-trip.
     * Authorised via Cerbos `activation_gate:update_item`.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateActivationGateItem
     */ updateActivationGateItem: {
            name: "UpdateActivationGateItem",
            I: UpdateActivationGateItemRequest,
            O: UpdateActivationGateItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * ActivateContract flips the ContractActivationGate to Activated when
     * every item is Complete or Waived. Server-side invariant: returns
     * `violations` (list of item_keys still Pending) when the gate isn't
     * ready, otherwise returns the activated gate. Authorised via Cerbos
     * `contract:activate`.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ActivateContract
     */ activateContract: {
            name: "ActivateContract",
            I: ActivateContractRequest,
            O: ActivateContractResponse,
            kind: MethodKind.Unary
        },
        /**
     * CloseDeliverableWithEvidence records evidence for one ProgramTask
     * (the SDS Deliverable) and, if the evidence rule passes, flips the
     * task to closed. The rule is the SDS §6.4 close-with-evidence
     * invariant: (artifact + POD) OR (external_reference + POD) OR
     * approved exception. Violations come back in-band as a list of
     * failure kinds so the UI renders inline guidance instead of having
     * to interpret a generic FailedPrecondition. Authorised via Cerbos
     * `deliverable:close_with_evidence`.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CloseDeliverableWithEvidence
     */ closeDeliverableWithEvidence: {
            name: "CloseDeliverableWithEvidence",
            I: CloseDeliverableWithEvidenceRequest,
            O: CloseDeliverableWithEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListDeliverableEvidence returns the evidence roster for one
     * ProgramTask. View-only; gated by Cerbos `deliverable_evidence:read`.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListDeliverableEvidence
     */ listDeliverableEvidence: {
            name: "ListDeliverableEvidence",
            I: ListDeliverableEvidenceRequest,
            O: ListDeliverableEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateDeliverableEvidence (SAD-106) updates the customer-facing
     * acceptance status / delivery notes / submitted-to on an
     * already-recorded evidence row, independent of the close flow.
     * Authorised via Cerbos `deliverable:update_evidence`.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateDeliverableEvidence
     */ updateDeliverableEvidence: {
            name: "UpdateDeliverableEvidence",
            I: UpdateDeliverableEvidenceRequest,
            O: UpdateDeliverableEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetFieldLineage returns every FieldLineage row for a single
     * (object_type, object_id, field_path) tuple, grouped by source_kind
     * server-side so the popover doesn't have to roll a switch on the
     * client. View-only; gated by Cerbos `field_lineage:read`.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetFieldLineage
     */ getFieldLineage: {
            name: "GetFieldLineage",
            I: GetFieldLineageRequest,
            O: GetFieldLineageResponse,
            kind: MethodKind.Unary
        },
        /**
     * PersistExtractionSourceRefs persists per-field source provenance emitted
     * by the V2 extractor on the everyday contract-upload path (not just the
     * analyst change-set flow). Writes provenance rows only — never authoritative
     * values — keyed by the extractor's natural keys (clin_number, etc.) with no
     * change_set. Reuses the same persist path as BeginAwardComparison. View
     * surfaces read it back via ListSourceReferencesByTarget. Best-effort caller
     * (reverie) — failures don't block the upload.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.PersistExtractionSourceRefs
     */ persistExtractionSourceRefs: {
            name: "PersistExtractionSourceRefs",
            I: PersistExtractionSourceRefsRequest,
            O: PersistExtractionSourceRefsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListSourceRefsForTarget returns the persisted per-field provenance for one
     * object (e.g. a CLIN by clin_number, or the program by contract_number), so
     * a SourceChip can show page/section/quote/confidence and drill to the
     * source. Browser-reachable (ProjectDataService is proxied via sabaody);
     * view-only.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListSourceRefsForTarget
     */ listSourceRefsForTarget: {
            name: "ListSourceRefsForTarget",
            I: ListSourceRefsForTargetRequest,
            O: ListSourceRefsForTargetResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListOpsAuditEvents — operational audit log query for the
     * OpsAuditTimeline. Filterable by action_key prefix, object,
     * actor_user_id, correlation_id, time window. View-only; gated by
     * Cerbos `ops_audit_event:read`.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListOpsAuditEvents
     */ listOpsAuditEvents: {
            name: "ListOpsAuditEvents",
            I: ListOpsAuditEventsRequest,
            O: ListOpsAuditEventsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetOpsAuditByCorrelation returns every event sharing a
     * correlation_id — drives the threaded view for multi-step user
     * actions (CommitImport, BeginAwardComparison, etc.). View-only;
     * same Cerbos action.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetOpsAuditByCorrelation
     */ getOpsAuditByCorrelation: {
            name: "GetOpsAuditByCorrelation",
            I: GetOpsAuditByCorrelationRequest,
            O: GetOpsAuditByCorrelationResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListMyActivity is Settings → History: the signed-in person's own
     * actions, newest first. The actor is the gateway principal. Pangaea
     * masks a record the caller can no longer read; this method turns the
     * surviving fields into a sentence and the same before/after detail the
     * program History tab shows.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListMyActivity
     */ listMyActivity: {
            name: "ListMyActivity",
            I: ListMyActivityRequest,
            O: ListMyActivityResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create a Capture Project: spawn a zou Project (type=capture) and the
     * backing pangaea govcon.capture_projects row for a pre-solicitation pursuit.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateCaptureProject
     */ createCaptureProject: {
            name: "CreateCaptureProject",
            I: CreateCaptureProjectRequest,
            O: CreateCaptureProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a Capture Project's editable metadata (name, stage, opportunity
     * hypothesis, account/customer-org linkage). Cerbos-gated on
     * capture_project:update; lifecycle changes use ChangeCaptureLifecycle.
     * Linking a Proposal leaves the Pursuit lifecycle and business phase unchanged.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateCaptureProject
     */ updateCaptureProject: {
            name: "UpdateCaptureProject",
            I: UpdateCaptureProjectRequest,
            O: UpdateCaptureProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-484. park/close/resume are explicit; record_outcome appends without changing lifecycle.
     * Requires expected_revision + stable request_id. Only selected open/in_progress tasks
     * may be parked, atomically. Resume never resumes tasks. No sibling/Watch mutation.
     * park: active -> parked; close: active/parked -> closed; resume: parked/closed -> active.
     * Stale revision or changed payload under a reused request_id returns Aborted.
     * Exact retry returns the original event plus the current capture snapshot.
     * Lifecycle mutation uses existing capture_project:update; history uses read.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ChangeCaptureLifecycle
     */ changeCaptureLifecycle: {
            name: "ChangeCaptureLifecycle",
            I: ChangeCaptureLifecycleRequest,
            O: ChangeCaptureLifecycleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureLifecycleEvents
     */ listCaptureLifecycleEvents: {
            name: "ListCaptureLifecycleEvents",
            I: ListCaptureLifecycleEventsRequest,
            O: ListCaptureLifecycleEventsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureSolution
     */ getCaptureSolution: {
            name: "GetCaptureSolution",
            I: GetCaptureSolutionRequest,
            O: GetCaptureSolutionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateCaptureSolutionHandoff
     */ createCaptureSolutionHandoff: {
            name: "CreateCaptureSolutionHandoff",
            I: CreateCaptureSolutionHandoffRequest,
            O: CreateCaptureSolutionHandoffResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureSolutionHandoffs
     */ listCaptureSolutionHandoffs: {
            name: "ListCaptureSolutionHandoffs",
            I: ListCaptureSolutionHandoffsRequest,
            O: ListCaptureSolutionHandoffsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveCaptureSolutionRevision
     */ saveCaptureSolutionRevision: {
            name: "SaveCaptureSolutionRevision",
            I: SaveCaptureSolutionRevisionRequest,
            O: SaveCaptureSolutionRevisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RestoreCaptureSolutionRevision
     */ restoreCaptureSolutionRevision: {
            name: "RestoreCaptureSolutionRevision",
            I: RestoreCaptureSolutionRevisionRequest,
            O: RestoreCaptureSolutionRevisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GenerateCaptureSolutionSuggestions
     */ generateCaptureSolutionSuggestions: {
            name: "GenerateCaptureSolutionSuggestions",
            I: GenerateCaptureSolutionSuggestionsRequest,
            O: GenerateCaptureSolutionSuggestionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureSolutionSuggestions
     */ listCaptureSolutionSuggestions: {
            name: "ListCaptureSolutionSuggestions",
            I: ListCaptureSolutionSuggestionsRequest,
            O: ListCaptureSolutionSuggestionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReviewCaptureSolutionSuggestion
     */ reviewCaptureSolutionSuggestion: {
            name: "ReviewCaptureSolutionSuggestion",
            I: ReviewCaptureSolutionSuggestionRequest,
            O: ReviewCaptureSolutionSuggestionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureSolutionAlternatives
     */ getCaptureSolutionAlternatives: {
            name: "GetCaptureSolutionAlternatives",
            I: GetCaptureSolutionAlternativesRequest,
            O: GetCaptureSolutionAlternativesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AddCaptureSolutionAlternative
     */ addCaptureSolutionAlternative: {
            name: "AddCaptureSolutionAlternative",
            I: AddCaptureSolutionAlternativeRequest,
            O: AddCaptureSolutionAlternativeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DecideCaptureSolutionAlternative
     */ decideCaptureSolutionAlternative: {
            name: "DecideCaptureSolutionAlternative",
            I: DecideCaptureSolutionAlternativeRequest,
            O: DecideCaptureSolutionAlternativeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AddCaptureSolutionGap
     */ addCaptureSolutionGap: {
            name: "AddCaptureSolutionGap",
            I: AddCaptureSolutionGapRequest,
            O: AddCaptureSolutionGapResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ResolveCaptureSolutionGap
     */ resolveCaptureSolutionGap: {
            name: "ResolveCaptureSolutionGap",
            I: ResolveCaptureSolutionGapRequest,
            O: ResolveCaptureSolutionGapResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureStaffing
     */ getCaptureStaffing: {
            name: "GetCaptureStaffing",
            I: GetCaptureStaffingRequest,
            O: GetCaptureStaffingResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveCaptureStaffingRevision
     */ saveCaptureStaffingRevision: {
            name: "SaveCaptureStaffingRevision",
            I: SaveCaptureStaffingRevisionRequest,
            O: SaveCaptureStaffingRevisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureStaffingReadiness
     */ getCaptureStaffingReadiness: {
            name: "GetCaptureStaffingReadiness",
            I: GetCaptureStaffingReadinessRequest,
            O: GetCaptureStaffingReadinessResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SaveCaptureStaffingReadiness
     */ saveCaptureStaffingReadiness: {
            name: "SaveCaptureStaffingReadiness",
            I: SaveCaptureStaffingReadinessRequest,
            O: SaveCaptureStaffingReadinessResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureTeamingPosition
     */ getCaptureTeamingPosition: {
            name: "GetCaptureTeamingPosition",
            I: GetCaptureTeamingPositionRequest,
            O: GetCaptureTeamingPositionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AddCapturePositionCapability
     */ addCapturePositionCapability: {
            name: "AddCapturePositionCapability",
            I: AddCapturePositionCapabilityRequest,
            O: AddCapturePositionCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ProposeCaptureTeamingCandidate
     */ proposeCaptureTeamingCandidate: {
            name: "ProposeCaptureTeamingCandidate",
            I: ProposeCaptureTeamingCandidateRequest,
            O: ProposeCaptureTeamingCandidateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetCaptureTeamingCandidateStatus
     */ setCaptureTeamingCandidateStatus: {
            name: "SetCaptureTeamingCandidateStatus",
            I: SetCaptureTeamingCandidateStatusRequest,
            O: SetCaptureTeamingCandidateStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReviseCaptureTeamingAssessment
     */ reviseCaptureTeamingAssessment: {
            name: "ReviseCaptureTeamingAssessment",
            I: ReviseCaptureTeamingAssessmentRequest,
            O: ReviseCaptureTeamingAssessmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureTeamingAgreements
     */ getCaptureTeamingAgreements: {
            name: "GetCaptureTeamingAgreements",
            I: GetCaptureTeamingAgreementsRequest,
            O: GetCaptureTeamingAgreementsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AddCaptureTeamingWorkshare
     */ addCaptureTeamingWorkshare: {
            name: "AddCaptureTeamingWorkshare",
            I: AddCaptureTeamingWorkshareRequest,
            O: AddCaptureTeamingWorkshareResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateCaptureTeamingAgreement
     */ createCaptureTeamingAgreement: {
            name: "CreateCaptureTeamingAgreement",
            I: CreateCaptureTeamingAgreementRequest,
            O: CreateCaptureTeamingAgreementResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetCaptureTeamingAgreementState
     */ setCaptureTeamingAgreementState: {
            name: "SetCaptureTeamingAgreementState",
            I: SetCaptureTeamingAgreementStateRequest,
            O: SetCaptureTeamingAgreementStateResponse,
            kind: MethodKind.Unary
        },
        /**
     * List the tenant's Capture Projects (summary rows) for the capture list
     * page. Each row carries both the capture_project_id and the zou project id.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureProjects
     */ listCaptureProjects: {
            name: "ListCaptureProjects",
            I: ListCaptureProjectsRequest,
            O: ListCaptureProjectsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-11 (SAD-1155): the Pursuits list read model (pursuit_read.proto).
     * capture_project list @ tenant root + per-row read; counts over readable
     * pursuits only; keyset paged.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListPursuits
     */ listPursuits: {
            name: "ListPursuits",
            I: ListPursuitsRequest,
            O: ListPursuitsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Read a Capture command-room workspace: the CaptureProject plus its RFI
     * events, customer interactions, and workstream items in one round-trip.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureWorkspace
     */ getCaptureWorkspace: {
            name: "GetCaptureWorkspace",
            I: GetCaptureWorkspaceRequest,
            O: GetCaptureWorkspaceResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create or update an RFI / market-research event (keyed on id; empty id
     * creates). Events are time-ordered so requirement drift is visible.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertRfiEvent
     */ upsertRfiEvent: {
            name: "UpsertRfiEvent",
            I: UpsertRfiEventRequest,
            O: UpsertRfiEventResponse,
            kind: MethodKind.Unary
        },
        /**
     * List RFI events for a capture project, ordered by event_date.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListRfiEvents
     */ listRfiEvents: {
            name: "ListRfiEvents",
            I: ListRfiEventsRequest,
            O: ListRfiEventsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create or update a customer-shaping interaction (keyed on id; empty id
     * creates). Time-ordered to show the interaction history.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DraftTouchpointProposals
     */ draftTouchpointProposals: {
            name: "DraftTouchpointProposals",
            I: DraftTouchpointProposalsRequest,
            O: DraftTouchpointProposalsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListTouchpointProposals
     */ listTouchpointProposals: {
            name: "ListTouchpointProposals",
            I: ListTouchpointProposalsRequest,
            O: ListTouchpointProposalsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReviewTouchpointProposal
     */ reviewTouchpointProposal: {
            name: "ReviewTouchpointProposal",
            I: ReviewTouchpointProposalRequest,
            O: ReviewTouchpointProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertCustomerInteraction
     */ upsertCustomerInteraction: {
            name: "UpsertCustomerInteraction",
            I: UpsertCustomerInteractionRequest,
            O: UpsertCustomerInteractionResponse,
            kind: MethodKind.Unary
        },
        /**
     * List customer interactions for a capture project, ordered by
     * interaction_date.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCustomerInteractions
     */ listCustomerInteractions: {
            name: "ListCustomerInteractions",
            I: ListCustomerInteractionsRequest,
            O: ListCustomerInteractionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create or update a per-workstream record (keyed on id; empty id creates).
     * Typed by CaptureWorkstreamType (the 8 §4 workstreams).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertWorkstreamItem
     */ upsertWorkstreamItem: {
            name: "UpsertWorkstreamItem",
            I: UpsertWorkstreamItemRequest,
            O: UpsertWorkstreamItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * List workstream items for a capture project, optionally filtered by
     * workstream_type.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListWorkstreamItems
     */ listWorkstreamItems: {
            name: "ListWorkstreamItems",
            I: ListWorkstreamItemsRequest,
            O: ListWorkstreamItemsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateRfiResponseProject
     */ createRfiResponseProject: {
            name: "CreateRfiResponseProject",
            I: CreateRfiResponseProjectRequest,
            O: CreateRfiResponseProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetRfiResponseWorkspace
     */ getRfiResponseWorkspace: {
            name: "GetRfiResponseWorkspace",
            I: GetRfiResponseWorkspaceRequest,
            O: GetRfiResponseWorkspaceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpdateRfiResponseProject
     */ updateRfiResponseProject: {
            name: "UpdateRfiResponseProject",
            I: UpdateRfiResponseProjectRequest,
            O: UpdateRfiResponseProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.LinkRfiResponseToCapture
     */ linkRfiResponseToCapture: {
            name: "LinkRfiResponseToCapture",
            I: LinkRfiResponseToCaptureRequest,
            O: LinkRfiResponseToCaptureResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UnlinkRfiResponseFromCapture
     */ unlinkRfiResponseFromCapture: {
            name: "UnlinkRfiResponseFromCapture",
            I: UnlinkRfiResponseFromCaptureRequest,
            O: UnlinkRfiResponseFromCaptureResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListRfiResponsesForCapture
     */ listRfiResponsesForCapture: {
            name: "ListRfiResponsesForCapture",
            I: ListRfiResponsesForCaptureRequest,
            O: ListRfiResponsesForCaptureResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureLinksForRfiResponse
     */ listCaptureLinksForRfiResponse: {
            name: "ListCaptureLinksForRfiResponse",
            I: ListCaptureLinksForRfiResponseRequest,
            O: ListCaptureLinksForRfiResponseResponse,
            kind: MethodKind.Unary
        },
        /**
     * Proposal <-> RFI Response M:N traceability (P-L3c).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.LinkRfiResponseToProposal
     */ linkRfiResponseToProposal: {
            name: "LinkRfiResponseToProposal",
            I: LinkRfiResponseToProposalRequest,
            O: LinkRfiResponseToProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UnlinkRfiResponseFromProposal
     */ unlinkRfiResponseFromProposal: {
            name: "UnlinkRfiResponseFromProposal",
            I: UnlinkRfiResponseFromProposalRequest,
            O: UnlinkRfiResponseFromProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListRfiResponsesForProposal
     */ listRfiResponsesForProposal: {
            name: "ListRfiResponsesForProposal",
            I: ListRfiResponsesForProposalRequest,
            O: ListRfiResponsesForProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProposalLinksForRfiResponse
     */ listProposalLinksForRfiResponse: {
            name: "ListProposalLinksForRfiResponse",
            I: ListProposalLinksForRfiResponseRequest,
            O: ListProposalLinksForRfiResponseResponse,
            kind: MethodKind.Unary
        },
        /**
     * Opportunity <-> RFI Response M:N (morgans notice_id). Reuses rfi_response
     * Cerbos link/unlink. No pangaea Notice/Opportunity table.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.LinkRfiResponseToOpportunity
     */ linkRfiResponseToOpportunity: {
            name: "LinkRfiResponseToOpportunity",
            I: LinkRfiResponseToOpportunityRequest,
            O: LinkRfiResponseToOpportunityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UnlinkRfiResponseFromOpportunity
     */ unlinkRfiResponseFromOpportunity: {
            name: "UnlinkRfiResponseFromOpportunity",
            I: UnlinkRfiResponseFromOpportunityRequest,
            O: UnlinkRfiResponseFromOpportunityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListRfiResponsesForOpportunity
     */ listRfiResponsesForOpportunity: {
            name: "ListRfiResponsesForOpportunity",
            I: ListRfiResponsesForOpportunityRequest,
            O: ListRfiResponsesForOpportunityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListOpportunityLinksForRfiResponse
     */ listOpportunityLinksForRfiResponse: {
            name: "ListOpportunityLinksForRfiResponse",
            I: ListOpportunityLinksForRfiResponseRequest,
            O: ListOpportunityLinksForRfiResponseResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create or update the Pursuit's go/no-go decision record (P-L3b). Empty
     * id creates; a second pending create folds into the open pending row.
     * Outcome is pending|go|defer — not no-bid/park/loss. No delete RPC.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertCaptureGoNoGoDecision
     */ upsertCaptureGoNoGoDecision: {
            name: "UpsertCaptureGoNoGoDecision",
            I: UpsertCaptureGoNoGoDecisionRequest,
            O: UpsertCaptureGoNoGoDecisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * List go/no-go decision records for a capture project (pending first).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureGoNoGoDecisions
     */ listCaptureGoNoGoDecisions: {
            name: "ListCaptureGoNoGoDecisions",
            I: ListCaptureGoNoGoDecisionsRequest,
            O: ListCaptureGoNoGoDecisionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCaptureProfile
     */ getCaptureProfile: {
            name: "GetCaptureProfile",
            I: GetCaptureProfileRequest,
            O: GetCaptureProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertCaptureProfile
     */ upsertCaptureProfile: {
            name: "UpsertCaptureProfile",
            I: UpsertCaptureProfileRequest,
            O: UpsertCaptureProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertCaptureTeamingLink
     */ upsertCaptureTeamingLink: {
            name: "UpsertCaptureTeamingLink",
            I: UpsertCaptureTeamingLinkRequest,
            O: UpsertCaptureTeamingLinkResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureTeamingLinks
     */ listCaptureTeamingLinks: {
            name: "ListCaptureTeamingLinks",
            I: ListCaptureTeamingLinksRequest,
            O: ListCaptureTeamingLinksResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteCaptureTeamingLink
     */ deleteCaptureTeamingLink: {
            name: "DeleteCaptureTeamingLink",
            I: DeleteCaptureTeamingLinkRequest,
            O: DeleteCaptureTeamingLinkResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertCaptureCompetitionLink
     */ upsertCaptureCompetitionLink: {
            name: "UpsertCaptureCompetitionLink",
            I: UpsertCaptureCompetitionLinkRequest,
            O: UpsertCaptureCompetitionLinkResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureCompetitionLinks
     */ listCaptureCompetitionLinks: {
            name: "ListCaptureCompetitionLinks",
            I: ListCaptureCompetitionLinksRequest,
            O: ListCaptureCompetitionLinksResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteCaptureCompetitionLink
     */ deleteCaptureCompetitionLink: {
            name: "DeleteCaptureCompetitionLink",
            I: DeleteCaptureCompetitionLinkRequest,
            O: DeleteCaptureCompetitionLinkResponse,
            kind: MethodKind.Unary
        },
        /**
     * Action-plan tasks on a Pursuit (G-2). Soft-delete only. Status is the
     * task row's own open|in_progress|done|parked — not capture_projects.stage.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertCaptureTask
     */ upsertCaptureTask: {
            name: "UpsertCaptureTask",
            I: UpsertCaptureTaskRequest,
            O: UpsertCaptureTaskResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCaptureTasks
     */ listCaptureTasks: {
            name: "ListCaptureTasks",
            I: ListCaptureTasksRequest,
            O: ListCaptureTasksResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteCaptureTask
     */ deleteCaptureTask: {
            name: "DeleteCaptureTask",
            I: DeleteCaptureTaskRequest,
            O: DeleteCaptureTaskResponse,
            kind: MethodKind.Unary
        },
        /**
     * ======================== Capture Plan projection (SAD-485 / CAP-01) ========================
     *
     * Capture Plan is a PROJECTION: GetCapturePlan reads the owning task,
     * review (proposal_milestones), decision (go/no-go), customer (capture
     * profile), partner (teaming links) and solution/output (workstream items)
     * records live on every call — it never copies their data into storage.
     * The only persisted state below is area metadata and its health ledger
     * (services/pangaea/pkg/models/capture_plan.go). Gated exactly like the
     * rest of this file: loadCaptureProjectForRead / loadCaptureProjectForMutation
     * (SAD-426); GetCapturePlan is scoped to one capture project, so that single
     * gate is the same bar as every other single-row read here.
     *
     * SetCapturePlanAreaHealth is the ONE path that moves an area's health — it
     * requires a resolved decider and rejects any value outside the five
     * accepted health strings. SuggestCapturePlanAreaHealth records an AI
     * proposal onto the health ledger and can never move health.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCapturePlan
     */ getCapturePlan: {
            name: "GetCapturePlan",
            I: GetCapturePlanRequest,
            O: GetCapturePlanResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertCapturePlanArea
     */ upsertCapturePlanArea: {
            name: "UpsertCapturePlanArea",
            I: UpsertCapturePlanAreaRequest,
            O: UpsertCapturePlanAreaResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteCapturePlanArea
     */ deleteCapturePlanArea: {
            name: "DeleteCapturePlanArea",
            I: DeleteCapturePlanAreaRequest,
            O: DeleteCapturePlanAreaResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetCapturePlanAreaHealth
     */ setCapturePlanAreaHealth: {
            name: "SetCapturePlanAreaHealth",
            I: SetCapturePlanAreaHealthRequest,
            O: SetCapturePlanAreaHealthResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SuggestCapturePlanAreaHealth
     */ suggestCapturePlanAreaHealth: {
            name: "SuggestCapturePlanAreaHealth",
            I: SuggestCapturePlanAreaHealthRequest,
            O: SuggestCapturePlanAreaHealthResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetCaptureTaskPlanArea
     */ setCaptureTaskPlanArea: {
            name: "SetCaptureTaskPlanArea",
            I: SetCaptureTaskPlanAreaRequest,
            O: SetCaptureTaskPlanAreaResponse,
            kind: MethodKind.Unary
        },
        /**
     * ======================== Customer Themes & pursuit stakeholders (SAD-491) ========================
     *
     * Thin browser-facing projection over pangaea's CaptureGatewayService
     * CustomerTheme / PursuitStakeholder RPCs (proto/mono/datagateway/v1/
     * capture.proto). Gated exactly like the rest of this file:
     * loadCaptureProjectForRead / loadCaptureProjectForMutation (SAD-426) —
     * see the file-level comment in services/zou/pkg/connecthandlers/themes.go
     * for why these single-project-scoped reads need no additional
     * filterGrowthScopeIDs pass.
     *
     * current_version_authorship is never a client-settable request field
     * here, matching pangaea's own wire contract: every mutation carries a
     * CustomerThemeVersionInput (no authorship field) rather than a whole
     * CustomerTheme, so an accepted theme's current version being
     * human-authored stays structurally unbreakable. SuggestCustomerTheme is
     * the one path that takes an explicit human|ai_suggested authorship on the
     * enclosing request, mirroring SuggestCustomerThemeRequest in capture.proto.
     *
     * ListStakeholderAssessments returns the sensitive pursuit-intel layer
     * (influence_band, relationship_posture, priorities, rationale,
     * uncertainty_note) gated by the same "view_sensitive" Cerbos action as
     * the rest of capture.go; a principal lacking it gets every row blanked,
     * never a truncated list.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListCustomerThemes
     */ listCustomerThemes: {
            name: "ListCustomerThemes",
            I: ListCustomerThemesRequest,
            O: ListCustomerThemesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCustomerTheme
     */ getCustomerTheme: {
            name: "GetCustomerTheme",
            I: GetCustomerThemeRequest,
            O: GetCustomerThemeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListStakeholderAssessments
     */ listStakeholderAssessments: {
            name: "ListStakeholderAssessments",
            I: ListStakeholderAssessmentsRequest,
            O: ListStakeholderAssessmentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateCustomerTheme
     */ createCustomerTheme: {
            name: "CreateCustomerTheme",
            I: CreateCustomerThemeRequest,
            O: CreateCustomerThemeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SuggestCustomerTheme
     */ suggestCustomerTheme: {
            name: "SuggestCustomerTheme",
            I: SuggestCustomerThemeRequest,
            O: SuggestCustomerThemeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AcceptCustomerThemeSuggestion
     */ acceptCustomerThemeSuggestion: {
            name: "AcceptCustomerThemeSuggestion",
            I: AcceptCustomerThemeSuggestionRequest,
            O: AcceptCustomerThemeSuggestionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReviseCustomerTheme
     */ reviseCustomerTheme: {
            name: "ReviseCustomerTheme",
            I: ReviseCustomerThemeRequest,
            O: ReviseCustomerThemeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AttachCustomerThemeEvidence
     */ attachCustomerThemeEvidence: {
            name: "AttachCustomerThemeEvidence",
            I: AttachCustomerThemeEvidenceRequest,
            O: AttachCustomerThemeEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListPursuitStakeholders
     */ listPursuitStakeholders: {
            name: "ListPursuitStakeholders",
            I: ListPursuitStakeholdersRequest,
            O: ListPursuitStakeholdersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertPursuitStakeholder
     */ upsertPursuitStakeholder: {
            name: "UpsertPursuitStakeholder",
            I: UpsertPursuitStakeholderRequest,
            O: UpsertPursuitStakeholderResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RecordStakeholderAssessment
     */ recordStakeholderAssessment: {
            name: "RecordStakeholderAssessment",
            I: RecordStakeholderAssessmentRequest,
            O: RecordStakeholderAssessmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-37: confirm an unresolved stakeholder / touchpoint attendee through
     * REG-54 DecideRegistryMatchCandidate (needs capture_project update).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ResolvePursuitEntity
     */ resolvePursuitEntity: {
            name: "ResolvePursuitEntity",
            I: ResolvePursuitEntityRequest,
            O: ResolvePursuitEntityResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-36: events (growth.event.list / growth.event.write, FND-25).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListEvents
     */ listEvents: {
            name: "ListEvents",
            I: ListEventsRequest,
            O: ListEventsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetEvent
     */ getEvent: {
            name: "GetEvent",
            I: GetEventRequest,
            O: GetEventResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertEvent
     */ upsertEvent: {
            name: "UpsertEvent",
            I: UpsertEventRequest,
            O: UpsertEventResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetEventLink
     */ setEventLink: {
            name: "SetEventLink",
            I: SetEventLinkRequest,
            O: SetEventLinkResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertProposalMilestone
     */ upsertProposalMilestone: {
            name: "UpsertProposalMilestone",
            I: UpsertProposalMilestoneRequest,
            O: UpsertProposalMilestoneResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListProposalMilestones
     */ listProposalMilestones: {
            name: "ListProposalMilestones",
            I: ListProposalMilestonesRequest,
            O: ListProposalMilestonesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteProposalMilestone
     */ deleteProposalMilestone: {
            name: "DeleteProposalMilestone",
            I: DeleteProposalMilestoneRequest,
            O: DeleteProposalMilestoneResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetCompetitiveField
     */ getCompetitiveField: {
            name: "GetCompetitiveField",
            I: GetCompetitiveFieldRequest,
            O: GetCompetitiveFieldResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertCompetitiveFieldParticipant
     */ upsertCompetitiveFieldParticipant: {
            name: "UpsertCompetitiveFieldParticipant",
            I: UpsertCompetitiveFieldParticipantRequest,
            O: UpsertCompetitiveFieldParticipantResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteCompetitiveFieldParticipant
     */ deleteCompetitiveFieldParticipant: {
            name: "DeleteCompetitiveFieldParticipant",
            I: DeleteCompetitiveFieldParticipantRequest,
            O: DeleteCompetitiveFieldParticipantResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RecordCompetitiveFieldAssessment
     */ recordCompetitiveFieldAssessment: {
            name: "RecordCompetitiveFieldAssessment",
            I: RecordCompetitiveFieldAssessmentRequest,
            O: RecordCompetitiveFieldAssessmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertCompetitiveFieldStrategy
     */ upsertCompetitiveFieldStrategy: {
            name: "UpsertCompetitiveFieldStrategy",
            I: UpsertCompetitiveFieldStrategyRequest,
            O: UpsertCompetitiveFieldStrategyResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Library reusable items (SAD-459 / LIB-01) --------
     *
     * Browser-edge discovery read path over pangaea's CaptureGatewayService
     * Library RPCs (proto/mono/datagateway/v1/capture.proto). No release /
     * adopt / freeze / withdraw RPC here — SAD-462/461/464/465 own the
     * lifecycle. GetLibraryItem and SearchLibraryItems share ONE authorization
     * predicate (libraryItemDenialReason in zou's library.go) so the two read
     * paths cannot drift the way SAD-426's growth-scope list filter once did.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.CreateLibraryItem
     */ createLibraryItem: {
            name: "CreateLibraryItem",
            I: CreateLibraryItemRequest,
            O: CreateLibraryItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetLibraryItem
     */ getLibraryItem: {
            name: "GetLibraryItem",
            I: GetLibraryItemRequest,
            O: GetLibraryItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SearchLibraryItems
     */ searchLibraryItems: {
            name: "SearchLibraryItems",
            I: SearchLibraryItemsRequest,
            O: SearchLibraryItemsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RecordCompetitorEvidence
     */ recordCompetitorEvidence: {
            name: "RecordCompetitorEvidence",
            I: RecordCompetitorEvidenceRequest,
            O: RecordCompetitorEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertBlackHatInput
     */ upsertBlackHatInput: {
            name: "UpsertBlackHatInput",
            I: UpsertBlackHatInputRequest,
            O: UpsertBlackHatInputResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteBlackHatInput
     */ deleteBlackHatInput: {
            name: "DeleteBlackHatInput",
            I: DeleteBlackHatInputRequest,
            O: DeleteBlackHatInputResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReviewBlackHatInput
     */ reviewBlackHatInput: {
            name: "ReviewBlackHatInput",
            I: ReviewBlackHatInputRequest,
            O: ReviewBlackHatInputResponse,
            kind: MethodKind.Unary
        },
        /**
     * Read the tenant's entity graph (nodes + edges) for the entity cards. The
     * UI joins edges to nodes by id client-side.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetEntityGraph
     */ getEntityGraph: {
            name: "GetEntityGraph",
            I: GetEntityGraphRequest,
            O: GetEntityGraphResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-35 (D-SOR 6): the pursuit's Knowledge graph - the entities the pursuit links
     * (plus claim subjects the caller may see) and 1-2 hops of neighbours from the govcon
     * graph projection. Requires pursuit read + the graph list check; writes nothing.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetPursuitGraph
     */ getPursuitGraph: {
            name: "GetPursuitGraph",
            I: GetPursuitGraphRequest,
            O: GetPursuitGraphResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create or update an entity node (company / gov_org / vehicle / partner).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertEntityNode
     */ upsertEntityNode: {
            name: "UpsertEntityNode",
            I: UpsertEntityNodeRequest,
            O: UpsertEntityNodeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Create or update an entity edge. Per §7 the edge requires provenance +
     * source + confidence; conflicting edges between the same nodes are kept as
     * competing edges, never silently overwritten.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UpsertEntityEdge
     */ upsertEntityEdge: {
            name: "UpsertEntityEdge",
            I: UpsertEntityEdgeRequest,
            O: UpsertEntityEdgeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Delete an entity node (soft-delete). Cascades to the node's incident edges
     * in one txn so the graph never shows an edge to a missing node. Cerbos
     * delete-gated + audited.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteEntityNode
     */ deleteEntityNode: {
            name: "DeleteEntityNode",
            I: DeleteEntityNodeRequest,
            O: DeleteEntityNodeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Delete an entity edge (soft-delete). Cerbos delete-gated + audited.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.DeleteEntityEdge
     */ deleteEntityEdge: {
            name: "DeleteEntityEdge",
            I: DeleteEntityEdgeRequest,
            O: DeleteEntityEdgeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Pin an edge as the user-confirmed canonical relationship; competing edges
     * are marked superseded. Writes a resolution-log row + ops-audit event.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.OverrideEntityEdge
     */ overrideEntityEdge: {
            name: "OverrideEntityEdge",
            I: OverrideEntityEdgeRequest,
            O: OverrideEntityEdgeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Merge two entity nodes (e.g. alias companies) into one, preserving the
     * secondary's name/ref as an alias and re-pointing its edges. Reversible via
     * the resolution log; writes an ops-audit event.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.MergeEntityNodes
     */ mergeEntityNodes: {
            name: "MergeEntityNodes",
            I: MergeEntityNodesRequest,
            O: MergeEntityNodesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Source-observation conflicts (SAD-455). List is entity_node list-gated;
     * resolve/reverse are admin-or-grant `merge` gated, need a rationale, and are
     * attributed to the authenticated user. Observations are never modified.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListObservationConflicts
     */ listObservationConflicts: {
            name: "ListObservationConflicts",
            I: ListObservationConflictsRequest,
            O: ListObservationConflictsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetEnrichmentState
     */ getEnrichmentState: {
            name: "GetEnrichmentState",
            I: GetEnrichmentStateRequest,
            O: GetEnrichmentStateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetEnrichmentEnabled
     */ setEnrichmentEnabled: {
            name: "SetEnrichmentEnabled",
            I: SetEnrichmentEnabledRequest,
            O: SetEnrichmentEnabledResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReverseEnrichment
     */ reverseEnrichment: {
            name: "ReverseEnrichment",
            I: ReverseEnrichmentRequest,
            O: ReverseEnrichmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ResolveObservationConflict
     */ resolveObservationConflict: {
            name: "ResolveObservationConflict",
            I: ResolveObservationConflictRequest,
            O: ResolveObservationConflictResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ReverseObservationResolution
     */ reverseObservationResolution: {
            name: "ReverseObservationResolution",
            I: ReverseObservationResolutionRequest,
            O: ReverseObservationResolutionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Refresh + dedup + origin adoption (SAD-458 / SRC-07). The dedup key is
     * the conflict fingerprint, so re-observing the same disagreement bumps an
     * existing exception instead of opening a new one. An adopted copy is
     * immutable: accepting a newer origin appends a row rather than
     * overwriting the one a consumer already has.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.RefreshSourceObservations
     */ refreshSourceObservations: {
            name: "RefreshSourceObservations",
            I: RefreshSourceObservationsRequest,
            O: RefreshSourceObservationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListObservationExceptions
     */ listObservationExceptions: {
            name: "ListObservationExceptions",
            I: ListObservationExceptionsRequest,
            O: ListObservationExceptionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AdoptOriginValue
     */ adoptOriginValue: {
            name: "AdoptOriginValue",
            I: AdoptOriginValueRequest,
            O: AdoptOriginValueResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListOriginAdoptions
     */ listOriginAdoptions: {
            name: "ListOriginAdoptions",
            I: ListOriginAdoptionsRequest,
            O: ListOriginAdoptionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ProjectDataService.AcceptNewerOrigin
     */ acceptNewerOrigin: {
            name: "AcceptNewerOrigin",
            I: AcceptNewerOriginRequest,
            O: AcceptNewerOriginResponse,
            kind: MethodKind.Unary
        },
        /**
     * Read the typed government org chart rooted at a gov_org node (agency ->
     * bureau -> office hierarchy + people/roles). Cerbos-gated read (Phase 1b-3).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetGovOrgChart
     */ getGovOrgChart: {
            name: "GetGovOrgChart",
            I: GetGovOrgChartRequest,
            O: GetGovOrgChartResponse,
            kind: MethodKind.Unary
        },
        /**
     * Reverse a merge by its resolution-log id (split): restores the secondary
     * node, re-points moved edges, drops the alias. Admin-or-grant gated +
     * audited (Phase 1b-4).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UnmergeEntityNodes
     */ unmergeEntityNodes: {
            name: "UnmergeEntityNodes",
            I: UnmergeEntityNodesRequest,
            O: UnmergeEntityNodesResponse,
            kind: MethodKind.Unary
        },
        /**
     * List the entity-resolution history (merge / split / override / pin), newest
     * first, so the UI can unmerge older merges. Cerbos-gated read (Phase 1b-4).
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListEntityResolutionLog
     */ listEntityResolutionLog: {
            name: "ListEntityResolutionLog",
            I: ListEntityResolutionLogRequest,
            O: ListEntityResolutionLogResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- GRW-04 (SAD-1115): pursuit <-> program "recompetes" link -----------
     * Link the program this pursuit recompetes. capture_project update + program
     * read; idempotent on request_id.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.LinkPursuitRecompete
     */ linkPursuitRecompete: {
            name: "LinkPursuitRecompete",
            I: LinkPursuitRecompeteRequest,
            O: LinkPursuitRecompeteResponse,
            kind: MethodKind.Unary
        },
        /**
     * Tombstone a recompete link (reason required). capture_project update.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.UnlinkPursuitRecompete
     */ unlinkPursuitRecompete: {
            name: "UnlinkPursuitRecompete",
            I: UnlinkPursuitRecompeteRequest,
            O: UnlinkPursuitRecompeteResponse,
            kind: MethodKind.Unary
        },
        /**
     * The pursuit's live recompete links whose program the caller may read.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListPursuitRecompetes
     */ listPursuitRecompetes: {
            name: "ListPursuitRecompetes",
            I: ListPursuitRecompetesRequest,
            O: ListPursuitRecompetesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Open a pursuit for a program and link it, retry-safe on request_id.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.OpenRecompetePursuit
     */ openRecompetePursuit: {
            name: "OpenRecompetePursuit",
            I: OpenRecompetePursuitRequest,
            O: OpenRecompetePursuitResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-04 v2.1 (OD-19): let readers of a recompeted program see the
     * content-free "Growth is working this" hint. capture_project update.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SetPursuitGrowthHint
     */ setPursuitGrowthHint: {
            name: "SetPursuitGrowthHint",
            I: SetPursuitGrowthHintRequest,
            O: SetPursuitGrowthHintResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- GRW-12 (SAD-1160): the pursuit header read model ------------------
     * Header, KPI strip and facts rail in one call (pursuit_read.proto).
     * capture_project read; program facts filtered by program read, black hat by
     * view_sensitive, RFI progress by rfi_response read.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.GetPursuitHeader
     */ getPursuitHeader: {
            name: "GetPursuitHeader",
            I: GetPursuitHeaderRequest,
            O: GetPursuitHeaderResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- GRW-13 (SAD-1044): the pursuit THREAD read model --------------------
     * Paginated, newest first; capture_project read; sensitive bodies masked
     * without view_sensitive, black-hat events dropped, links filtered.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListThread
     */ listThread: {
            name: "ListThread",
            I: ListThreadRequest,
            O: ListThreadResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- GRW-18 (SAD-1080): graph surgery (pursuit_surgery.proto) ------------
     * Components a pursuit could give away, with blocked reasons. capture_project read.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.PlanPursuitSurgery
     */ planPursuitSurgery: {
            name: "PlanPursuitSurgery",
            I: PlanPursuitSurgeryRequest,
            O: PlanPursuitSurgeryResponse,
            kind: MethodKind.Unary
        },
        /**
     * Claim before materialise: opens the sibling through the retry-safe opening
     * path, then moves the chosen components. update on the source + create at root.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.SplitPursuit
     */ splitPursuit: {
            name: "SplitPursuit",
            I: SplitPursuitRequest,
            O: SplitPursuitResponse,
            kind: MethodKind.Unary
        },
        /**
     * The loser becomes a read-only stub pointing at the survivor. update on both.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.MergePursuits
     */ mergePursuits: {
            name: "MergePursuits",
            I: MergePursuitsRequest,
            O: MergePursuitsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Move / link / detach components between two pursuits. update on both.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.MovePursuitComponents
     */ movePursuitComponents: {
            name: "MovePursuitComponents",
            I: MovePursuitComponentsRequest,
            O: MovePursuitComponentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Surgery events where the pursuit is the source or the target. capture_project read.
     *
     * @generated from rpc mono.projectdata.v1.ProjectDataService.ListPursuitSurgery
     */ listPursuitSurgery: {
            name: "ListPursuitSurgery",
            I: ListPursuitSurgeryRequest,
            O: ListPursuitSurgeryResponse,
            kind: MethodKind.Unary
        }
    }
};
